/* FOMOFITS v2: a calm, simple storefront (Home, Shop, Product) with bag, saved, search and a phone menu.
   Data: window.FOMO_CATALOG (fomofits.com snapshot). Brand art: window.FOMO_BRAND (vector kit, eyes only in the logo).
   Pages are real links (#/shop/leggings, #/p/army), so the back button just works. Checkout opens the store's own cart. */
(() => {
  'use strict';
  const B = window.FOMO_BRAND;
  const C = window.FOMO_CATALOG;
  const STORE = 'https://fomofits.com';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = (n) => `${Number(n).toFixed(3)} JOD`;
  /* Almost gone (19 Sep): 10% off every colour with one size left, as an automatic discount in Shopify ("Almost gone
     −10%", on the almost-gone collection, which follows the product tag). Shopify gives one automatic discount per
     order, the bigger one, so a set saving and this 10% never add up; the bag shows exactly that. */
  const AG_OFF = 0;   // 26 Sep: the Almost gone −10% automatic discount is off for the 40% sale
  const r2 = (n) => Math.round(n * 100) / 100;
  const agPrice = (c) => r2(c.price * (1 - AG_OFF));
  // 26 Sep sale: Shopify's compare-at price arrives as v.was / c.was; show the new price first, the old one struck through
  const priceTag = (c) => (c.almost ? `${money(agPrice(c))} <s>${money(c.was || c.price)}</s>` : c.was ? `${money(c.price)} <s>${money(c.was)}</s>` : money(c.price));
  const store = {
    get(k, d) { try { const v = window.localStorage.getItem(`fomo2.${k}`); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
    set(k, v) { try { window.localStorage.setItem(`fomo2.${k}`, JSON.stringify(v)); } catch (e) { /* memory only */ } },
  };
  const PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.3a4.3 4.3 0 0 1 7.5 2.5C19.5 15.4 12 20 12 20z"/></svg>';
  const LEFT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  const SHARE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 15V4"/><path d="m8 8 4-4 4 4"/><path d="M5 13v6h14v-6"/></svg>';
  const RIGHT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  const PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor" stroke="none"/></svg>';
  // real posts from @fomo.fits (saved 19 Sep 2026 from fomo/grid): shortcode + kind; the tile links to the post itself
  const IG_POSTS = [['DaLd9tToiWx', 'reel'], ['DZF1ps8IMiL', 'reel'], ['DZ24kGfIHzX', 'p'], ['DZXoWbUIavQ', 'reel'], ['DZAT1UpiM-j', 'p'], ['DZkil0Rof60', 'p'], ['DZIp7OdCG1K', 'p'], ['DQpVL-cCEiq', 'p']];

  /* ---------------- data ---------------- */
  /* Live stock (19 Sep, his call: "make the site read from the real inventory"). On the shop, theme.liquid writes
     every piece's current variants into window.FOMO_LIVE on each page view, so stock and prices are Shopify's own,
     like any store. A variant Shopify no longer sells counts as sold out; a new single-colour product added to one of
     the site's collections appears on its own with its Shopify photos. Off the shop (the preview link) the saved copy is used. */
  (function applyLive() {
    const L = window.FOMO_LIVE; if (!L) return;
    const SZ = { 'x-small': 'XS', xs: 'XS', small: 'S', s: 'S', medium: 'M', m: 'M', large: 'L', l: 'L', 'x-large': 'XL', xl: 'XL', 'xx-large': 'XXL', xxl: 'XXL' };
    const sizeOf = (t) => { for (const part of String(t).split(' / ')) { const k = SZ[part.trim().toLowerCase()]; if (k) return k; } return ''; };
    const byVar = new Map(); Object.values(L).forEach((ps) => ps.forEach((p) => p.v.forEach((v) => byVar.set(v[0], v))));
    const agVar = new Set(); Object.values(L).forEach((ps) => ps.forEach((p) => { if (p.a) p.v.forEach((v) => agVar.add(v[0])); }));
    const known = new Set();
    // a piece Shopify no longer sells at all (deleted, drafted or unpublished) leaves the site instead of showing sold out
    C.lines.forEach((l) => { l.colours = l.colours.filter((c) => c.variants.some((v) => byVar.has(v.id))); });
    C.lines.forEach((l) => l.colours.forEach((c) => {
      known.add(c.handle || String(c.key).split('~')[0]);
      c.variants.forEach((v) => { const x = byVar.get(v.id); if (x) { v.available = !!x[1]; v.price = x[2] / 100; v.max = x[4] == null ? null : Math.max(0, x[4]); v.was = x[5] > x[2] ? x[5] / 100 : null; } else v.available = false; });
      if (c.variants[0]) { c.price = c.variants[0].price; c.was = c.variants[0].was || null; }
      c.soldOut = !c.variants.some((v) => v.available);
      c.almost = c.variants.some((v) => agVar.has(v.id));   // tagged almost-gone in Shopify: the 10% checkout gives
    }));
    C.lines.forEach((l) => (L[l.id] || []).forEach((p) => {
      if (known.has(p.h) || !p.i.length || !p.v.length) return;
      known.add(p.h);
      l.colours.push({ key: p.h, handle: p.h, name: (p.t.split(' — ')[1] || p.t).trim(), price: p.v[0][2] / 100, hex: '#8a8a8a', family: '', new: true,
        images: p.i.map((src) => ({ src, w: 1000, h: 1250 })), was: p.v[0][5] > p.v[0][2] ? p.v[0][5] / 100 : null, variants: p.v.map((v) => ({ id: v[0], size: sizeOf(v[3]), available: !!v[1], price: v[2] / 100, max: v[4] == null ? null : Math.max(0, v[4]), was: v[5] > v[2] ? v[5] / 100 : null })),
        soldOut: !p.v.some((v) => v[1]), almost: !!p.a });
    }));
  }());
  const lines = C.lines;
  const lineById = (id) => lines.find((l) => l.id === id);
  const byKey = new Map();
  // his names on the site (18 Sep); the Shopify product titles stay as they are until he says otherwise
  const RENAME = { 'fomo-leggings': 'Original Cut Leggings', 'fomo-cloud-leggings': 'High Waisted Cloud Leggings',
    'highwaisted-flare': 'High Waisted Flare Pants', 'original-flare-pants': 'Original Low Waisted Flare Pants' };
  lines.forEach((line) => { if (RENAME[line.id]) line.name = RENAME[line.id]; });
  lines.forEach((line) => line.colours.forEach((c) => {
    c.line = line;
    c.sizes = c.variants.filter((v) => v.size);
    c.avail = c.sizes.filter((v) => v.available);
    c.soldOut = c.variants.every((v) => !v.available);
    c.lastSize = c.avail.length === 1 && c.sizes.length > 1;
    if (!window.FOMO_LIVE) c.almost = c.lastSize;
    c.almost = !!c.almost && !c.soldOut;
    byKey.set(c.key, c);
  }));
  const all = lines.flatMap((l) => l.colours);
  const live = all.filter((c) => !c.soldOut);
  const GROUPS = {
    new: { title: 'New in', hl: ['New', 'in'], pick: (c) => c.new },
    leggings: { title: 'Leggings', hl: ['The', 'leggings'], pick: (c) => c.line.group === 'leggings' },
    cloud: { title: 'Leggings · Cloud cut', hl: ['Cloud', 'cut'], pick: (c) => c.line.id === 'fomo-cloud-leggings', hidden: true },
    highwaist: { title: 'Leggings · Original cut', hl: ['Original', 'cut'], pick: (c) => c.line.id === 'fomo-leggings', hidden: true },
    tops: { title: 'Tops', hl: ['The', 'tops'], pick: (c) => c.line.group === 'tops' },
    jackets: { title: 'Jackets', hl: ['The', 'jackets'], pick: (c) => c.line.group === 'jackets' },
    flares: { title: 'Flares', hl: ['The', 'flares'], pick: (c) => c.line.group === 'flares' },
    essentials: { title: 'Essentials', hl: ['The', 'essentials'], pick: (c) => c.line.group === 'essentials' },
    all: { title: 'Shop all', hl: ['Shop', 'all'], pick: () => true },
  };
  const groupOf = (c) => (c.line.group in GROUPS ? c.line.group : 'all');
  const FAMS = { black: 'Black', white: 'White', cream: 'Cream', brown: 'Brown', grey: 'Grey', blue: 'Blue', green: 'Green', pink: 'Pink', red: 'Red', purple: 'Purple' };
  const SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
  const CUTS = { 'fomo-cloud-leggings': { name: 'Cloud cut', group: 'cloud', line: 'A higher waist than the Original cut, and extra comfortable.' },
    'fomo-leggings': { name: 'Original cut', group: 'highwaist', line: 'High-waisted, body-shaping and comfortable.' } };
  const sameName = (a, b) => a.toLowerCase().replace(/gray/g, 'grey') === b.toLowerCase().replace(/gray/g, 'grey');

  /* ---------------- offers: a mirror of the automatic discounts in Shopify (created 17 Sep 2026, scheduled for launch day) ----------------
     Each set takes a fixed amount off once the set pieces in the bag reach the minimum; only the best one applies.
     Free delivery counts the order after the set saving. Checkout applies the real discounts; this only shows them early. */
  const OFFER_SETS = [];   // 26 Sep: the three set discounts are deactivated in Shopify for the 40% sale
  const OFFER_SETS_OFF = [
    { name: 'The Studio Set', off: 7, min: 67, lines: ['fomo-leggings', 'fitted-zip-jacket'] },
    { name: 'The Everyday Set', off: 9, min: 89, lines: ['fomo-leggings', 'fitted-zip-jacket', 'cozy-curve-top'] },
    { name: 'The Full Look Set', off: 16, min: 115, lines: ['fomo-leggings', 'fitted-zip-jacket', 'cozy-curve-top', 'wrap-over-top'] },
  ];
  const FREE_FROM = 50;
  const FEES = { amman: 3, other: 5 };
  // what goes with what, in order of preference (the lines shot together in his photos come first)
  const PARTNER = {
    'fomo-leggings': ['fitted-zip-jacket', 'cozy-curve-top', 'wrap-over-top'], 'fitted-zip-jacket': ['fomo-leggings', 'fomo-cloud-leggings'],
    'cozy-curve-top': ['fomo-leggings', 'fomo-cloud-leggings'], 'wrap-over-top': ['fomo-leggings', 'fomo-cloud-leggings'],
    'fomo-cloud-leggings': ['cloud-wrap-up', 'ribbed-tank-yop', 'fitted-zip-jacket'], 'cloud-wrap-up': ['fomo-cloud-leggings', 'highwaisted-flare'],
    'ribbed-tank-yop': ['highwaisted-flare', 'fomo-cloud-leggings'], 'highwaisted-flare': ['ribbed-tank-yop', 'cloud-wrap-up'],
  };
  const title = (c) => (c.name ? `${c.line.name}, ${c.name}` : c.line.name);
  // One piece from each line in turn, so a row never opens with four colours of the same thing.
  function interleave(items, order = []) {
    const buckets = new Map();
    items.forEach((c) => { if (!buckets.has(c.line.id)) buckets.set(c.line.id, []); buckets.get(c.line.id).push(c); });
    const ids = [...order.filter((id) => buckets.has(id)), ...[...buckets.keys()].filter((id) => !order.includes(id))];
    const out = [];
    for (let i = 0; out.length < items.length; i += 1) ids.forEach((id) => { const c = buckets.get(id)[i]; if (c) out.push(c); });
    return out;
  }

  /* ---------------- hero ---------------- */
  // Two heroes while Ezzaldeen chooses (?hero=b previews the second).
  // A: his own photo, sky widened on Higgsfield; the real pixels are untouched.
  // B: an AI model in the Cloud Wrap Over Top, mirrored so the tie sits on the right hip as on the real top.
  const HEROES = {
    a: { src: (window.A_ + 'img--hero-a'), h: 1223, m: (window.A_ + 'img--hero-a-m.webp'), mh: 1251, pos: '50% 38%', mpos: '50% 34%', side: 'left', tone: 'light', piece: 'navy-blue-copy', alt: 'Cloud Wrap Over Top in Cloud White, arms raised against a blue sky' },
    b: { src: (window.A_ + 'img--hero-b'), h: 1357, m: (window.A_ + 'img--hero-b-m.webp'), mh: 1250, pos: '50% 28%', mpos: '50% 12%', side: 'right', tone: 'dark', piece: 'navy-blue-copy', alt: 'Cloud Wrap Over Top in Cloud White with black leggings on a limestone street' },
  };
  const heroId = (() => { try { return new URLSearchParams(window.location.search).get('hero') === 'b' ? 'b' : 'a'; } catch (e) { return 'a'; } })();

  const S = {
    bag: store.get('bag', []).filter((i) => byKey.has(i.key) && byKey.get(i.key).variants.some((v) => v.id === i.variantId)),
    saved: store.get('saved', []).filter((k) => byKey.has(k)),
    city: store.get('city', 'amman'),
    size: null,
    pref: store.get('size', null),     // the size she picked last, used by quick add
    seen: store.get('seen', []).filter((k) => byKey.has(k)),   // recently viewed, this phone only
  };
  const F = { g: null, fam: null, size: null, sort: 'new', mine: false };   // shop page filters

  // pieces that complete an outfit with c: the other half (top ↔ bottom), partner lines first, same colour name next; one per line
  function goesWith(c, n = 3, skip = new Set()) {
    const want = c.line.mix === 'bottom' ? 'top' : c.line.mix === 'top' ? 'bottom' : null;
    const pref = PARTNER[c.line.id] || [];
    const score = (x) => (pref.includes(x.line.id) ? 10 - pref.indexOf(x.line.id) : 0) + (sameName(x.name, c.name) ? 4 : 0) + (x.family === c.family ? 1 : 0) + (x.new ? 1 : 0);
    const best = new Map();
    live.filter((x) => x.line !== c.line && !skip.has(x.key) && (want ? x.line.mix === want : !!x.line.mix))
      .forEach((x) => { const b = best.get(x.line.id); if (!b || score(x) > score(b)) best.set(x.line.id, x); });
    return [...best.values()].sort((a, b) => score(b) - score(a)).slice(0, n);
  }

  /* ---------------- pieces ---------------- */
  const logo = (svg) => svg;
  function dots(c) {
    const sibs = c.line.colours;
    if (sibs.length < 2 || !c.hex) return '<div class="pc__dots" aria-hidden="true"></div>';
    const shown = sibs.slice(0, 5);
    return `<div class="pc__dots" aria-hidden="true">${shown.map((x) => `<i class="${x.key === c.key ? 'on' : ''}" style="--c:${esc(x.hex || '#999')}"></i>`).join('')}${sibs.length > 5 ? `<span>+${sibs.length - 5}</span>` : ''}</div>`;
  }
  function card(c) {
    const [a, b] = c.images;
    // Almost gone: "−10%" and the size left as two short tags, one under the other; one long tag ran under the ♡ on
    // phone-width cards, and the size in the grey line under the name was too easy to miss (19 Sep)
    const badge = c.soldOut ? 'Sold out' : c.almost ? 'Almost gone' : c.lastSize ? `Only ${c.avail[0].size} left` : '';
    const badge2 = c.almost && c.avail.length === 1 ? `Only ${c.avail[0].size} left` : '';
    const saved = S.saved.includes(c.key);
    return `<article class="pc">
      <div class="pc__frame">
      <a class="pc__media" href="${pHref(c.key)}" aria-label="${esc(title(c))}">
        <img class="a" src="${a.src}" width="${a.w}" height="${a.h}" alt="" loading="lazy" decoding="async">
        ${b ? `<img class="b" src="${b.src}" alt="" loading="lazy" decoding="async">` : ''}
        ${badge ? `<span class="pc__badges"><span class="pc__badge${c.almost ? ' pc__badge--off' : ''}">${badge}</span>${badge2 ? `<span class="pc__badge">${badge2}</span>` : ''}</span>` : ''}
      </a>
      ${c.soldOut ? '' : `<button class="pc__add" type="button" data-quick="${esc(c.key)}" aria-label="Quick add: ${esc(title(c))}">${PLUS}</button>`}
      <button class="icon pc__save" type="button" data-save="${esc(c.key)}" aria-pressed="${saved}" aria-label="${saved ? 'Remove from saved' : 'Save'}: ${esc(title(c))}">${HEART}</button>
      </div>
      <div class="pc__info">
        ${dots(c)}
        <a class="pc__name" href="${pHref(c.key)}">${esc(c.line.name)}</a>
        <p class="pc__meta">${esc(c.name || `${c.line.colours.length} colours`)}</p>
        <p class="pc__price num">${priceTag(c)}</p>
      </div>
    </article>`;
  }
  function row(id, heading, items, more) {
    if (!items.length) return '';
    return `<section class="section" aria-labelledby="${id}-t">
      <div class="section__head">
        <h2 class="title" id="${id}-t">${esc(heading)}</h2>
        <div class="arrows">
          ${more ? `<a class="textlink" href="${more}" style="margin-right:8px">Shop all</a>` : ''}
          <button class="icon" type="button" data-scroll="${id}" data-d="-1" aria-label="Scroll ${esc(heading)} back">${LEFT}</button>
          <button class="icon" type="button" data-scroll="${id}" data-d="1" aria-label="Scroll ${esc(heading)} forward">${RIGHT}</button>
        </div>
      </div>
      <div class="row" id="${id}">${items.map(card).join('')}</div>
    </section>`;
  }
  const img = (src, alt, w = 1200, h = 1500, eager = false) => `<img src="${src}" width="${w}" height="${h}" alt="${esc(alt)}" sizes="(max-width: 860px) 50vw, 25vw" ${eager ? 'fetchpriority="high"' : 'loading="lazy"'} decoding="async">`;
  // warm the next page: when she hovers or starts a tap on a card, fetch that product's photos
  const warmed = new Set();
  function warm(key) {
    const c = byKey.get(key); if (!c || warmed.has(key)) return;
    warmed.add(key);
    c.images.slice(0, 2).forEach((im) => { const l = document.createElement('link'); l.rel = 'prefetch'; l.as = 'image'; l.href = im.src; document.head.appendChild(l); });
  }
  const keyOf = (href) => {
    if (href.startsWith('#/p/')) return decodeURIComponent(href.slice(4));
    const m = href.match(/^\/products\/([^/?#]+)(?:\?c=([^&#]+))?/); if (!m) return '';
    const h = decodeURIComponent(m[1]); return m[2] ? `${h}~${decodeURIComponent(m[2])}` : byKey.has(h) ? h : ((live.find((c) => c.handle === h) || {}).key || '');
  };
  const warmFrom = (t) => { const a = t.closest && t.closest('a[href^="#/p/"], a[href^="/products/"]'); if (a) { const k = keyOf(a.getAttribute('href')); if (k) warm(k); } };
  document.addEventListener('pointerover', (e) => warmFrom(e.target), { passive: true });
  document.addEventListener('touchstart', (e) => warmFrom(e.target), { passive: true });
  const prefFor = (c) => (S.pref && c.avail.some((v) => v.size === S.pref) ? S.pref : '');
  // a small row: photo, name, colour, price and a one-tap add in her remembered size
  function mini(c, why = '') {
    const sz = prefFor(c);
    const href = `${pHref(c.key)}`;
    return `<div class="mini">
      <a class="mini__img" href="${href}" tabindex="-1" aria-hidden="true">${img(c.images[0].src, '', c.images[0].w, c.images[0].h)}</a>
      <div class="mini__info">
        ${why ? `<span class="mini__why">${esc(why)}</span>` : ''}
        <a class="mini__name" href="${href}">${esc(c.line.name)}</a>
        <span>${esc(c.name)} · <span class="num">${money(c.price)}</span></span>
      </div>
      <button class="mini__add" type="button" data-quick="${esc(c.key)}" ${sz ? 'data-direct="1"' : ''} aria-label="Add ${esc(title(c))}${sz ? `, size ${sz}` : ''}">${PLUS}<span>${sz ? `Add · ${sz}` : 'Add'}</span></button>
    </div>`;
  }

  /* ---------------- pages ---------------- */
  /* one card per line: colour dots switch the photo, name and price in place */
  function lineCard(id) {
    const line = lineById(id);
    const cols = line.colours.filter((c) => !c.soldOut);
    if (!cols.length) return '';
    const c = cols[0];
    const [a, b] = c.images;
    return `<article class="pc lc" data-line="${esc(id)}">
      <div class="pc__frame">
      <a class="pc__media" href="${pHref(c.key)}" aria-label="${esc(title(c))}">
        <img class="a" src="${a.src}" width="${a.w}" height="${a.h}" alt="" loading="lazy" decoding="async">
        ${b ? `<img class="b" src="${b.src}" alt="" loading="lazy" decoding="async">` : ''}
      </a>
      <button class="pc__add" type="button" data-quick="${esc(c.key)}" aria-label="Quick add: ${esc(title(c))}">${PLUS}</button>
      </div>
      <div class="pc__info">
        <div class="lc__dots" role="group" aria-label="${esc(line.name)} colours">${cols.map((x, i) => `<button type="button" data-swatch="${esc(x.key)}" aria-pressed="${i === 0}" aria-label="${esc(x.name)}" style="--c:${esc(x.hex || '#999')}"></button>`).join('')}</div>
        <a class="pc__name" href="${pHref(c.key)}">${esc(line.name)}</a>
        <p class="pc__meta"><span class="lc__colour">${esc(c.name)}</span> · ${cols.length} colours</p>
        <p class="pc__price num">${priceTag(c)}</p>
      </div>
    </article>`;
  }
  // Fitted Zip Jacket + Original Cut Leggings sharing a colour name (store data, 16 Sep); the set price is the Studio Set discount (active since 18 Sep)
  const SETS = [['Deep Black', 'fitted-zip-jacket-copy-copy-copy-copy', 'high-waist-black-leggings'], ['Olive', 'fitted-zip-jacket-copy', 'olive'],
    ['Moon Grey', 'tight-jacket', 'high-waist-gray-leggings'], ['Charcoal Grey', 'fitted-zip-jacket-copy-copy', 'high-waist-maroon-leggings']];
  const SET_SAVE = 0;   // 26 Sep: set discounts are off for the 40% sale
  function setCard([name, jk, lk]) {
    const j = byKey.get(jk); const l = byKey.get(lk);
    if (!j || !l || j.soldOut || l.soldOut) return '';
    const total = j.price + l.price;
    // 20 Sep, his call: one photo of the whole outfit (the jacket shot, worn with the matching leggings); a tap opens the sizes for both pieces
    return `<article class="pc set">
      <button class="pc__media set__media" type="button" data-set="${esc(jk)},${esc(lk)}" data-setname="The ${esc(name)} set" aria-label="Choose sizes for the ${esc(name)} set">
        <img class="a" src="${j.images[0].src}" width="${j.images[0].w}" height="${j.images[0].h}" alt="Fitted Zip Jacket and Original Cut Leggings in ${esc(name)}" loading="lazy" decoding="async">
      </button>
      <div class="pc__info">
        <span class="pc__name">The ${esc(name)} set</span>
        <p class="pc__meta">Fitted Zip Jacket + Original Cut Leggings</p>
        <p class="pc__price num">${SET_SAVE ? `${money(total - SET_SAVE)} <s>${money(total)}</s>` : money(total)}</p>
        <button class="btn btn--small" type="button" data-set="${esc(jk)},${esc(lk)}" data-setname="The ${esc(name)} set">Add the set</button>
      </div>
    </article>`;
  }

  // book page furniture: a pair of eyes, the page number and its name; the right side carries a quiet detail
  const EYES = `<span class="fur__eyes" aria-hidden="true">${B.eyes}</span>`;
  const bar = (n, label, right = '') => `<div class="pg__bar"><span class="fur">${EYES}${n ? `${n} — ` : ''}${label}</span>${right ? `<span class="fur fur--r">${right}</span>` : ''}</div>`;
  // two-part headlines read as one phrase in Arabic, not word by word ("الـ tops" was the result)
  const HL_AR = { 'New in': ['وصل', 'حديثاً'], 'The leggings': ['', 'اللجنز'], 'Cloud cut': ['قصّة', 'Cloud'], 'Original cut': ['القصّة', 'الأصلية'],
    'The tops': ['', 'البلايز'], 'The jackets': ['', 'الجاكيتات'], 'The flares': ['', 'الفلير'], 'The essentials': ['', 'الأساسيات'], 'On @fomo.fits': ['على', '@fomo.fits'], 'Before you order': ['قبل أن', 'تطلبي'] };
  const hl = (thin, bold, id = '', tag = 'h2') => {
    const ar = window.FOMO_LANG === 'ar' && HL_AR[`${thin} ${bold}`]; if (ar) [thin, bold] = ar;
    return `<${tag} class="hl"${id ? ` id="${id}"` : ''}>${thin ? `<span class="thin">${thin}</span> ` : ''}<span class="bold">${bold}</span></${tag}>`;
  };
  const credit = `<span class="pg__credit" aria-hidden="true">${B.logoH}<span>FITS</span></span>`;
  const corner = `<span class="pg__corner" aria-hidden="true">${B.eyesStacked}</span>`;

  /* ---------------- Style it ----------------
     One complete photograph per outfit, all four shot on the same model, same pose, same wall and scaled to the
     same height, so switching a piece changes only the clothes. No cut-and-paste seams.
     The garments are AI-rendered from his real product photos, so the page says so and links to the real photos. */
  const STYLE = {
    tops: [
      { id: 'wrap', key: 'navy-blue-copy', label: 'Cloud Wrap Over Top' },
      { id: 'tank', key: 'black', label: 'Ribbed Tank Top' },
    ],
    bottoms: [
      { id: 'leg', key: 'olive-copy', label: 'High Waisted Cloud Leggings' },
      { id: 'flare', key: 'navy-blue-high-waist-flare-pants', label: 'High-Waist Flare Pants' },
    ],
  };
  const STYLE_ON = false;   // hidden 18 Sep until it is developed right; #/style falls through to home
  const ST = { top: 0, bottom: 0 };
  const styleFit = () => [STYLE.tops[ST.top], STYLE.bottoms[ST.bottom]].map((x) => byKey.get(x.key)).filter(Boolean);
  const styleShot = () => `${window.A_}img--style--fit-${STYLE.tops[ST.top].id}-${STYLE.bottoms[ST.bottom].id}.webp`;
  function styleStage() {
    const t = STYLE.tops[ST.top]; const b = STYLE.bottoms[ST.bottom];
    return `<div class="stage stage--fit">
      <img id="fitShot" src="${styleShot()}" width="760" height="1140" alt="${esc(t.label)} with ${esc(b.label)} on the FOMO model" decoding="async" fetchpriority="high">
    </div>`;
  }
  function stylePicks() {
    const pick = (group, list, on) => `<div class="pick">
      <span class="fur">${EYES}${group === 'tops' ? 'Top' : 'Bottom'}</span>
      <div class="pick__row">${list.map((x, i) => {
        const c = byKey.get(x.key);
        return `<button class="pick__b" type="button" data-pick="${group}" data-i="${i}" aria-pressed="${i === on}" aria-label="${esc(x.label)}, ${esc(c ? c.name : '')}">
          <span class="pick__img">${img(c.images[0].src, '', c.images[0].w, c.images[0].h)}</span>
          <span class="pick__t">${esc(x.label)}</span>
          <span class="pick__c">${esc(c ? c.name : '')} · <span class="num">${money(c.price)}</span></span>
        </button>`;
      }).join('')}</div>
    </div>`;
    return pick('tops', STYLE.tops, ST.top) + pick('bottoms', STYLE.bottoms, ST.bottom);
  }
  function styleSide() {
    const fit = styleFit();
    const total = fit.reduce((a, c) => a + c.price, 0);
    return `${stylePicks()}
      <div class="look__total"><span>The fit</span><span class="num">${money(total)}</span></div>
      <button class="btn btn--wide" type="button" data-set="${fit.map((c) => c.key).join(',')}" data-setname="Your fit">Add the fit · choose sizes</button>
      <p class="hint">Styling preview on our model. Every piece is the real product — open it to see the real photos:
        ${fit.map((c) => `<a class="textlink" href="${pHref(c.key)}">${esc(c.line.name)}</a>`).join(' ')}</p>`;
  }
  function stylePage() {
    return `<div class="pg pg--style">
      ${bar('', 'Style it', 'Mix and match')}
      <div class="section__head"><div>${hl('Style it', 'on her', 'style-t', 'h1')}<p class="sub">Pick a top and a bottom and see the whole fit on one model. Then add both in one step.</p></div></div>
      <div class="styler">
        <div class="styler__stage" id="stageHolder">${styleStage()}</div>
        <div class="styler__side" id="styleSide">${styleSide()}</div>
      </div>
    </div>`;
  }
  // swap the photo only when the new one has loaded, so the figure never flickers or half-draws
  function restyle() {
    const sd = $('#styleSide'); if (sd) sd.innerHTML = styleSide();
    const shot = $('#fitShot'); if (!shot) return;
    const next = styleShot();
    if (shot.getAttribute('src') === next) return;
    const t = STYLE.tops[ST.top]; const b = STYLE.bottoms[ST.bottom];
    const pre = new Image();
    pre.onload = () => { shot.src = next; shot.alt = `${t.label} with ${b.label} on the FOMO model`; shot.classList.remove('is-swapping'); };
    shot.classList.add('is-swapping');
    pre.src = next;
  }

  /* ---------------- Exchange request ----------------
     She finds her order by order number or phone, picks the pieces, says why, chooses what she wants instead,
     and sends the request. The rules are his: 3 days from delivery, unworn with tags, no returns,
     JOD 3 in Amman / JOD 5 elsewhere because a driver collects and delivers.
     DEMO DATA: this prototype has no server, so three sample orders stand in for the real lookup.
     Connecting it to real orders needs Shopify customer accounts or a small server; see README. */
  // 19 Sep: real orders, no demo. The site can't read Shopify orders safely from the browser, so she tells us
  // her order and what she received; we check the order number before we confirm (the summary says so).
  const EX_REASONS = ['Too small', 'Too big', 'Wrong colour', 'Not what I expected', 'Faulty'];
  const EX = { order: null, step: 1, picks: {}, sent: false, sentNo: '', form: { no: '', phone: '', city: 'amman', delivered: '', rows: [{ key: '', size: '' }] } };
  const today = () => new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10);
  const daysSince = (iso) => Math.floor((Date.now() - new Date(`${iso}T12:00:00`).getTime()) / 86400000);
  const exFee = (city) => (city === 'amman' ? 3 : 5);
  // she can swap for any piece: she pays the price difference plus delivery (3 JD Amman, 5 JD elsewhere)
  const exTarget = (x, p) => byKey.get(p.other || p.colour || x.c.key) || x.c;
  const exDiff = (x, p) => exTarget(x, p).price - x.c.price;
  function exMoney(o) {
    const rows = exLines(o).filter((x) => EX.picks[x.i]);
    const diff = rows.reduce((t, x) => t + Math.max(0, exDiff(x, EX.picks[x.i])), 0);
    const cheaper = rows.some((x) => exDiff(x, EX.picks[x.i]) < 0);
    const fee = exFee(o.city);
    return { diff, fee, total: diff + fee, cheaper, n: rows.length };
  }

  function exchangePage() {
    return `<div class="pg pg--ex">
      ${bar('', 'Exchange an item', 'Within 3 days')}
      <div class="section__head"><div>${hl('Exchange', 'an item', 'ex-t', 'h1')}
        <p class="sub">Find your order, pick what you'd like to exchange, and tell us what you'd like instead. We reply within a few hours.</p></div></div>
      <ol class="steps" aria-label="Steps">
        ${['Your order', 'What to exchange', 'Send'].map((t, i) => `<li class="${EX.step > i + 1 ? 'done' : EX.step === i + 1 ? 'on' : ''}"><span class="num">${i + 1}</span>${t}</li>`).join('')}
      </ol>
      <div id="exBody">${exBody()}</div>
    </div>`;
  }
  function exBody() {
    if (EX.sent) return exDone();
    if (!EX.order) return exFind();
    return EX.step === 2 ? exPick() : exSend();
  }
  // every piece she could have bought (sold-out colours too), grouped by piece, in the site's names
  const EX_ALL = () => { const by = new Map(); lines.forEach((l) => l.colours.forEach((c) => { if (!by.has(l.name)) by.set(l.name, []); by.get(l.name).push(c); })); return [...by.entries()]; };
  /* Step 1 (20 Sep, his call): no typed form. Signed in, her orders are listed from window.FOMO_ORDERS and an order
     still inside the 3-day window starts the exchange in one tap; older orders say so. Not signed in, she signs in
     with the email she used at checkout (Shopify emails a code). Orders placed without an email go through Instagram. */
  function exFind(err = '') {
    const mine = Array.isArray(window.FOMO_ORDERS) ? window.FOMO_ORDERS.filter((o) => o && o.items && o.items.length) : null;
    const ig = `<a class="textlink" href="https://ig.me/m/fomo.fits" target="_blank" rel="noopener">Message us on Instagram</a>`;
    let body;
    if (mine && mine.length) {
      body = `<div class="exorders">
        <span class="fur">${EYES}Your orders</span>
        ${mine.map((o) => {
    const d = o.delivered || o.at; const age = daysSince(d); const open = age <= 3;
    return `<div class="exorder-card ${open ? '' : 'exorder-card--closed'}">
          <div class="exorder-card__info"><b>Order #${esc(String(o.no))}</b><span>${exDate(d)}${o.city ? ` · ${esc(o.city)}` : ''}</span>
            <p>${o.items.map((it) => `${esc(it.t || '')}${it.vt && it.vt !== 'Default Title' ? ` · ${esc(it.vt)}` : ''}${it.q > 1 ? ` ×${it.q}` : ''}</p>`).join('')}
            ${open ? '' : `<span class="exorder-card__closed">Exchange window closed · ${age} days since delivery</span>`}</div>
          ${open ? `<button class="btn btn--small" type="button" data-exorder="${esc(String(o.no))}">Exchange from this order</button>`
    : `<button class="textlink" type="button" data-exorder="${esc(String(o.no))}">Details</button>`}
        </div>`;
  }).join('')}
        <p class="hint">Exchanges are within 3 days of delivery. Ordered without an email? ${ig} with your order number.</p>
        ${err ? `<p class="exerr" role="alert">${esc(err)}</p>` : ''}
      </div>`;
    } else {
      body = `<div class="exorders exorders--in">
        <span class="fur">${EYES}Your orders</span>
        <p>Sign in with the email you used at checkout and your orders appear here with their pieces. We email you a code, no password, and you stay signed in.</p>
        <a class="btn" href="/account">Sign in with your email</a>
        <p class="hint">Ordered without an email? ${ig} with your order number.</p>
      </div>`;
    }
    return `<div class="exbox">
      ${body}
      <aside class="exrules">
        <span class="fur">${EYES}The rules</span>
        <ul>
          <li>Up to <b>3 days</b> from delivery.</li>
          <li>Unworn, in original condition, all tags attached.</li>
          <li>Exchange only — no returns.</li>
          <li>Swap for any piece: pay the price difference plus delivery.</li>
          <li>Delivery fee: JOD 3 in Amman, JOD 5 in other cities.</li>
        </ul>
      </aside>
    </div>`;
  }
  // one of her real orders becomes step 1, filled in: number, phone, city, the day it arrived and every piece in it
  function exFromOrder(no) {
    const o = (window.FOMO_ORDERS || []).find((x) => String(x.no) === String(no));
    if (!o) return;
    const byVariant = new Map(); all.forEach((c) => c.variants.forEach((v) => byVariant.set(String(v.id), { key: c.key, size: v.size || '—' })));
    const items = [];
    o.items.forEach((it) => { const m = byVariant.get(String(it.v)); if (m) for (let k = 0; k < (it.q || 1); k += 1) items.push({ key: m.key, size: m.size, qty: 1 }); });
    if (!items.length) { $('#exBody').innerHTML = exFind('The pieces in this order are not on the site any more. Message us on Instagram and we will sort the exchange by hand.'); return; }
    const city = /amman|عم/i.test(o.city || '') ? 'amman' : 'other';
    EX.form.no = String(o.no); EX.form.phone = o.phone || ''; EX.form.city = city; EX.form.delivered = o.delivered || o.at;
    EX.order = { no: String(o.no), phone: o.phone || '', name: '', city, placed: o.at, delivered: o.delivered || o.at, items, mine: true };
    EX.picks = {}; EX.step = 2; EX.sent = false;
    route();
  }
  const exLines = (o) => o.items.map((it, i) => ({ ...it, i, c: byKey.get(it.key) })).filter((x) => x.c);
  const exDate = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  // past 3 days she still sees exactly what she ordered, with a plain reason why it cannot be exchanged
  function exClosed(o, age) {
    const total = exLines(o).reduce((a, x) => a + x.c.price * x.qty, 0);
    return `<div class="exbox">
      <div class="exorder">
        <div class="pg__bar"><span class="fur">${EYES}Order #${esc(o.no)}</span><span class="fur">Delivered ${esc(exDate(o.delivered))}</span></div>
        <div class="exclosed" role="alert">
          <p class="exclosed__t">This order can't be exchanged.</p>
          <p>Exchanges are within 3 days of delivery. Your order arrived on ${esc(exDate(o.delivered))}, which is ${age} days ago, so the 3 days have passed.</p>
          <p>If a piece has a fault, message us on Instagram and we'll look at it.</p>
        </div>
        <span class="fur">${EYES}What you ordered</span>
        ${exLines(o).map((x) => `<div class="exline exline--flat">
          <span class="exline__img">${img(x.c.images[0].src, '', x.c.images[0].w, x.c.images[0].h)}</span>
          <span class="exline__info"><b>${esc(x.c.line.name)}</b><span>${esc(x.c.name)} · size ${esc(x.size)} · ${x.qty} piece${x.qty === 1 ? '' : 's'}</span></span>
          <span class="num">${money(x.c.price * x.qty)}</span>
        </div>`).join('')}
        <div class="exline exline--total"><span><b>Total</b></span><span class="num">${money(total)}</span></div>
        <p class="hint">Delivered to ${o.city === 'amman' ? 'Amman' : 'another city'}</p>
      </div>
      <div class="exfoot">
        <div class="exbtns">
          <a class="btn" href="https://ig.me/m/fomo.fits" target="_blank" rel="noopener">Message us on Instagram</a>
          <a class="btn btn--ghost" href="#/shop/new">Shop the new collection</a>
          <button class="btn btn--ghost" type="button" data-exback>Another order</button>
        </div>
      </div>
    </div>`;
  }
  const FAMILIES_FOR_EX = () => {
    const by = new Map();
    live.filter((c) => !c.soldOut).forEach((c) => { const k = c.line.name; if (!by.has(k)) by.set(k, []); by.get(k).push(c); });
    return [...by.entries()];
  };
  function exPick() {
    const o = EX.order; const age = daysSince(o.delivered);
    if (age > 3) return exClosed(o, age);
    const left = 3 - age;
    return `<div class="exbox">
      <div class="exorder">
        <div class="pg__bar"><span class="fur">${EYES}Order #${esc(o.no)}</span><span class="fur">Delivered ${esc(exDate(o.delivered))} · ${left === 0 ? 'last day to exchange' : `${left} day${left === 1 ? '' : 's'} left`}</span></div>
        ${exLines(o).map((x) => {
    const picked = EX.picks[x.i];
    const sizes = x.c.avail.map((v) => v.size);
    const sibs = x.c.line.colours.filter((sc) => !sc.soldOut);
    return `<div class="exline ${picked ? 'is-on' : ''}">
          <label class="exline__head">
            <input type="checkbox" data-expick="${x.i}" ${picked ? 'checked' : ''}>
            <span class="exline__img">${img(x.c.images[0].src, '', x.c.images[0].w, x.c.images[0].h)}</span>
            <span class="exline__info"><b>${esc(x.c.line.name)}</b><span>${esc(x.c.name)} · size ${esc(x.size)} · <span class="num">${money(x.c.price)}</span></span></span>
          </label>
          ${picked ? `<div class="exline__opts">
            <div class="opt"><span class="opt__label">What's wrong?</span>
              <div class="sizes">${EX_REASONS.map((r) => `<button type="button" class="size" data-exreason="${x.i}" data-val="${r}" aria-pressed="${picked.reason === r}">${r}</button>`).join('')}</div>
            </div>
            ${picked.other ? '' : `<div class="opt"><span class="opt__label">Swap for which size?</span>
              <div class="sizes">${sizes.map((z) => `<button type="button" class="size" data-exsize="${x.i}" data-val="${z}" aria-pressed="${picked.size === z}" ${z === x.size ? 'disabled' : ''}>${z}</button>`).join('')}</div>
              ${sizes.length ? '' : '<p class="hint">Every size of this piece is sold out right now. Pick another colour or another piece below.</p>'}
            </div>`}
            ${sibs.length > 1 ? `<div class="opt"><span class="opt__label">Or another colour</span>
              <div class="colours">${sibs.map((sc) => `<button type="button" data-excolour="${x.i}" data-val="${esc(sc.key)}" aria-pressed="${picked.colour === sc.key}" title="${esc(sc.name)}" aria-label="${esc(sc.name)}">${img(sc.images[0].src, '', sc.images[0].w, sc.images[0].h)}</button>`).join('')}</div>
            </div>` : ''}
            <div class="opt"><label class="opt__label" for="exOther${x.i}">Or a different piece</label>
              <select class="exselect" id="exOther${x.i}" data-exother="${x.i}">
                <option value="">Choose any piece…</option>
                ${FAMILIES_FOR_EX().map(([name, list]) => `<optgroup label="${esc(name)}">${list.map((c) => `<option value="${esc(c.key)}" ${picked.other === c.key ? 'selected' : ''}>${esc(c.line.name)} · ${esc(c.name)} · ${money(c.price)}</option>`).join('')}</optgroup>`).join('')}
              </select>
              ${picked.other ? (() => {
    const t = byKey.get(picked.other); const d = exDiff(x, picked);
    return `<div class="exother">
                <span class="exline__img">${img(t.images[0].src, '', t.images[0].w, t.images[0].h)}</span>
                <div><b>${esc(t.line.name)}</b><span>${esc(t.name)} · ${money(t.price)}</span>
                <span class="exother__d">${d > 0 ? `You pay the difference: <b class="num">${money(d)}</b>` : d === 0 ? 'Same price: no difference to pay' : 'This piece costs less. We\'ll confirm the difference with you.'}</span></div>
              </div>
              <span class="opt__label">Size of the new piece</span>
              <div class="sizes">${t.sizes.length ? t.sizes.map((v) => `<button type="button" class="size" data-exsize="${x.i}" data-val="${v.size}" aria-pressed="${picked.size === v.size}" ${v.available ? '' : 'disabled'}>${v.size}</button>`).join('') : '<span class="hint">One size</span>'}</div>`;
  })() : ''}
            </div>
          </div>` : ''}
        </div>`;
  }).join('')}
      </div>
      <div class="exfoot">
        <p class="hint">${Object.keys(EX.picks).length ? (() => { const m = exMoney(o); return `${m.n} piece${m.n === 1 ? '' : 's'} chosen · ${m.diff ? `difference ${money(m.diff)} + ` : ''}delivery ${money(m.fee)} = <b class="num">${money(m.total)}</b>${m.cheaper ? ' · a cheaper piece: we\'ll confirm the difference' : ''}`; })() : 'Tick the pieces you want to exchange.'}</p>
        <div class="exbtns">
          <button class="btn btn--ghost" type="button" data-exback>Another order</button>
          <button class="btn" type="button" data-exnext ${Object.keys(EX.picks).length ? '' : 'disabled'}>Continue</button>
        </div>
      </div>
    </div>`;
  }
  function exSummary() {
    const o = EX.order;
    const lines = Object.entries(EX.picks).map(([i, p]) => {
      const x = exLines(o).find((y) => String(y.i) === String(i));
      const t = exTarget(x, p); const d = exDiff(x, p);
      const want = p.other ? `${t.line.name}, ${t.name}${p.size ? `, size ${p.size}` : ''}` : p.colour ? `${t.name}${p.size ? `, size ${p.size}` : ''}` : `size ${p.size || '—'}`;
      const dd = d > 0 ? ` · difference JOD ${d}` : d < 0 ? ' · cheaper piece, difference to confirm' : '';
      return `${x.c.line.name}, ${x.c.name}, size ${x.size} → ${want} (${p.reason || 'reason not given'})${dd}`;
    });
    const m = exMoney(o);
    return `FOMOFITS exchange request\nOrder #${o.no} · ${o.phone} · delivered ${o.delivered}\n${lines.map((l) => `• ${l}`).join('\n')}\nDelivery: ${o.city === 'amman' ? 'Amman' : 'Outside Amman'} · JOD ${m.fee}\n${m.diff ? `Price difference: JOD ${m.diff}\n` : ''}To pay: JOD ${m.total} · cash on delivery or CliQ, when it is delivered\nI confirm the pieces are unworn with tags attached.`;
  }
  function exSend() {
    const o = EX.order;
    return `<div class="exbox">
      <div class="exorder">
        <div class="pg__bar"><span class="fur">${EYES}Check and send</span><span class="fur">Order #${esc(o.no)}</span></div>
        <pre class="exsummary">${esc(exSummary())}</pre>
        <label class="excheck"><input type="checkbox" id="exAgree"> <span>The pieces are unworn, in original condition, with all tags attached.</span></label>
        ${(() => { const m = exMoney(o); return `<p class="hint">You pay <b class="num">${money(m.total)}</b>: ${m.diff ? `the price difference ${money(m.diff)} plus ` : ''}delivery ${money(m.fee)}${o.city === 'amman' ? ' in Amman' : ' outside Amman'}. Pay by cash on delivery or CliQ, when the new piece is delivered, not before. We reply within a few hours.</p>`; })()}
      </div>
      <div class="exfoot">
        <!-- Shopify's own contact form: the request lands in the shop inbox as an email. The store's spam check hooks
             the real submit, so this is a plain POST, not a fetch. Off Shopify the submit is intercepted for the demo. -->
        <form class="exform exmail" id="exMail" method="post" action="/contact#contact_form">
          <input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓">
          <input type="hidden" name="contact[Order]" value="#${esc(o.no)}">
          ${o.phone ? `<input type="hidden" name="contact[Phone]" value="${esc(o.phone)}">` : ''}
          <textarea name="contact[body]" hidden readonly>${esc(exSummary())}</textarea>
          <input type="hidden" name="return_to" value="/pages/exchange?sent=${esc(o.no)}">
          <label class="exfield"><span>Your email · we reply here</span><input type="email" name="contact[email]" required autocomplete="email" placeholder="you@example.com" value="${esc(window.FOMO_CUSTOMER_EMAIL || '')}"></label>
          <div class="exbtns">
            <button class="btn btn--ghost" type="button" data-exstep="2">Back</button>
            <button class="btn" type="submit" data-exsend disabled>Send the request by email</button>
          </div>
          <p class="hint">We reply by email within a few hours. Nothing is charged until the new piece arrives.</p>
        </form>
      </div>
    </div>`;
  }
  function exDone() {
    const o = EX.order; const no = o ? o.no : EX.sentNo;
    return `<div class="exbox exbox--done">
      <div class="exorder">
        <span class="empty__face" aria-hidden="true">${B.oEyes}</span>
        <p class="empty__t">Request sent.</p>
        <p>Your exchange request${no ? ` for order #${esc(String(no))}` : ''} is in our inbox. We reply by email within a few hours, and nothing is charged until the new piece arrives.</p>
        ${o ? `<pre class="exsummary">${esc(exSummary())}</pre>` : ''}
        <div class="exbtns"><a class="btn btn--ghost" href="#/shop/all">Back to the shop</a></div>
      </div>
    </div>`;
  }
  function exRender() { const b = $('#exBody'); if (b) { b.innerHTML = exBody(); reveal(b); } const st = $('.steps'); if (st) st.outerHTML = ''; const p = $('.pg--ex'); if (p && !$('.steps', p)) { /* steps rebuilt with the page */ } }


  /* ---------------- About and Help ----------------
     Every line here is his own wording from fomofits.com (About page, policies, exchange page).
     Nothing is invented: no phone number, no opening hours, no measurements, no rating claim. */
  function aboutPage() {
    return `<div class="pg">
      ${bar('', 'About', 'Est. 2022')}
      <div class="section__head"><div>${hl('Born in Jordan', 'made for the world', '', 'h1')}</div></div>
      <div class="prose">
        <p class="lead">FOMOFITS was founded in Jordan in 2022 with a clear vision: to build a local brand that meets global standards. We create lifestyle pieces using high-quality fabrics, modern fits, and a strong commitment to craftsmanship, style, and customer experience.</p>
        <p>Designed for the modern Jordanian woman with a global perspective.</p>
        <div class="vals">
          <div><span class="fur">${EYES}Quality first</span><p>High-quality fabrics and modern fits, made to last.</p></div>
          <div><span class="fur">${EYES}Community &amp; identity</span><p>More than a brand — a movement.</p></div>
          <div><span class="fur">${EYES}Customer first</span><p>Same day in Amman, cash on delivery, and an easy exchange.</p></div>
        </div>
        <p class="fur">Amman — Jordan · 31.963158 N, 35.930359 E</p>
        <div class="hero__btns"><a class="btn" href="#/shop/new">Shop the new collection</a><a class="btn btn--ghost" href="https://ig.me/m/fomo.fits" target="_blank" rel="noopener">Message us on Instagram</a></div>
      </div>
    </div>
    <section class="chapter chapter--grey" aria-label="Own your FOMO">
        ${corner}
        ${bar('', 'Born in Jordan', 'Lifestyle | Casual | Daily fits')}
        <div class="chapter__body">
          <span class="chapter__art" aria-hidden="true">${B.artsy}</span>
          <div class="chapter__text">
            ${hl("Don't just follow trends.", 'Own your FOMO')}
            <p>Leggings, tops, jackets and flares made to move with you, from Amman to everywhere.</p>
            <a class="btn" href="#/shop/new">Shop the new collection</a>
          </div>
        </div>
        ${credit}
      </section>`;
  }
  /* Shopify's policy pages (/policies/refund-policy and the rest; checkout links to them). Until 19 Sep they showed the
     home page. The text is whatever is written in Shopify > Settings > Policies, shown inside the site's frame. */
  function policyPage() {
    const d = document.createElement('div'); d.innerHTML = window.FOMO_POLICY || '';
    const h = d.querySelector('.shopify-policy__title, h1'); const t = (h ? h.textContent : '').trim() || 'Policy';
    if (h) h.remove();
    d.querySelectorAll('script, style, link').forEach((x) => x.remove());
    d.querySelectorAll('*').forEach((x) => { x.removeAttribute('style'); x.removeAttribute('class'); x.removeAttribute('id'); });
    const said = d.textContent.replace(/[\s\-–—]/g, '');
    return { title: t, html: `<div class="pg">
      ${bar('', t, 'FOMOFITS')}
      <div class="section__head"><div><h1 class="hl"><span class="bold">${esc(t)}</span></h1></div></div>
      <div class="prose policy">${said ? d.innerHTML : '<p>Message us on Instagram <a href="https://ig.me/m/fomo.fits" target="_blank" rel="noopener">@fomo.fits</a> with any question about this.</p>'}
        <div class="hero__btns"><a class="btn" href="#/help">Delivery, exchange and help</a></div>
      </div>
    </div>` };
  }
  function helpPage() {
    return `<div class="pg">
      ${bar('', 'Delivery, exchange and help', 'Amman · Jordan')}
      <div class="section__head"><div>${hl('How ordering', 'works', '', 'h1')}</div></div>
      <div class="prose">
        <div class="vals">
          <div><span class="fur">${EYES}Payment</span><p>Cash or CliQ on delivery: pay when you receive your order.</p></div>
          <div><span class="fur">${EYES}Delivery</span><p>Same day in Amman for orders before 4 pm, JOD 3. Other cities in Jordan, JOD 5, within 1–2 working days.<br>Free delivery on orders over ${FREE_FROM} JOD.</p></div>
          <div><span class="fur">${EYES}Exchange</span><p>You have up to 3 days to exchange your item, as long as it is in its original condition, unworn and with all tags attached. No returns allowed. A delivery fee is charged: JOD 3 in Amman, JOD 5 in other cities.</p></div>
          <div><span class="fur">${EYES}Questions</span><p>Message us on Instagram and we'll get back to you within a few hours.</p></div>
        </div>
        <div class="hero__btns">
          <a class="btn" href="#/exchange">Start an exchange</a>
          <a class="btn btn--ghost" href="https://ig.me/m/fomo.fits" target="_blank" rel="noopener">DM @fomo.fits</a>
        </div>
      </div>
    </div>`;
  }

  function setsPage() {
    const sets = SETS.map(setCard).filter(Boolean);
    return `<div class="pg">
      ${bar('', 'Matching sets', `${sets.length} colours`)}
      <div class="section__head"><div>${hl('Matching', 'sets', 'sets-t', 'h1')}<p class="sub">The Fitted Zip Jacket and the Original Cut Leggings in the same colour.${SET_SAVE ? ` Save ${SET_SAVE} JOD when you take both.` : ''}</p></div></div>
      <div class="grid sets">${sets.join('')}</div>
    </div>`;
  }
  function home() {
    const H = HEROES[heroId];
    const almost = live.filter((c) => c.almost);
    const tank = byKey.get('navy-blue'); const flare = byKey.get('navy-blue-high-waist-flare-pants');
    const cloud = lineById('fomo-cloud-leggings'); const hw = lineById('fomo-leggings');
    const liveOf = (l) => l.colours.filter((c) => !c.soldOut);
    const priceRange = (l) => { const p = [...new Set(liveOf(l).map((c) => c.price))].sort((x, y) => x - y); return p.length > 1 ? `${p[0]}–${p[p.length - 1]} JOD` : `${p[0]} JOD`; };
    const shot = (c) => c.images[0];
    const sets = SETS.map(setCard).filter(Boolean);
    // the six collections with their photos (his 19 Sep note: "the remaining collections are not clearly showing"), as one sliding row
    const cats = [['new', 'New in', (window.A_ + 'img--amman-020735.webp'), 1200, 1600], ['leggings', 'Leggings', (window.A_ + 'img--amman-160604.webp'), 1200, 1501],
      ['tops', 'Tops', (window.A_ + 'img--amman-151352.webp'), 1200, 1599], ['jackets', 'Jackets', (window.A_ + 'img--fitted-zip-jacket-copy-0.webp'), 1000, 1250],
      ['flares', 'Flares', shot(byKey.get('black-high-waist-flare-pants')).src, 1000, 1250], ['essentials', 'Essentials', (window.A_ + 'img--t-shirt-fomo-0.webp'), 1000, 1250]];
    /* 19 Sep audit: the home is a story in eight numbered pages: cover, the pieces, the collections, the choice, proof,
       almost gone, who we are, the questions she asks before ordering, then one last shop button. */
    const TOTAL = 8; const pn = (n) => `${String(n).padStart(2, '0')} / ${String(TOTAL).padStart(2, '0')}`;
    return `
      <section class="hero hero--${heroId} hero--${H.side} hero--${H.tone}" aria-labelledby="heroTitle">
        <div class="hero__media">
          <picture>
            <source media="(max-width: 860px)" srcset="${H.m}" width="1000" height="${H.mh}">
            <img src="${H.src}-1600.webp" srcset="${H.src}-1600.webp 1600w, ${H.src}-2400.webp 2400w" sizes="100vw" width="2400" height="${H.h}" alt="${esc(H.alt)}" fetchpriority="high" decoding="async" style="--pos:${H.pos};--mpos:${H.mpos}">
          </picture>
          <span class="hero__mark" aria-hidden="true">${B.logoStack}</span>
          <div class="hero__fur"><span class="fur">${EYES}01 — The cover</span><span class="fur"><bdi>31°57′47″ N 35°55′49″ E</bdi></span></div>
        </div>
        <div class="hero__cap">
          ${hl('You wear to', 'represent', 'heroTitle', 'h1')}
          <div class="hero__side">
            <p>Lifestyle pieces born in Jordan, made for the world.</p>
            <div class="hero__btns"><a class="btn" href="#/shop/new">Shop the new collection</a></div>
          </div>
        </div>
      </section>

      <section class="pg" aria-labelledby="new-t">
        ${bar('02', 'The new collection', pn(2))}
        <div class="section__head">
          <div>${hl('The new', 'collection', 'new-t')}<p class="sub">Tap a colour to see it.</p></div>
          <div class="arrows"><a class="textlink" href="#/shop/new">Shop all</a></div>
        </div>
        <div class="row row--4" id="new">${['fomo-cloud-leggings', 'cloud-wrap-up', 'ribbed-tank-yop', 'highwaisted-flare'].map(lineCard).join('')}</div>
      </section>

      <section class="pg" aria-labelledby="cats-t">
        ${bar('03', 'Shop by category', pn(3))}
        <div class="section__head"><div>${hl('Shop by', 'category', 'cats-t')}</div>
          <div class="arrows">
            <button class="icon" type="button" data-scroll="cats" data-d="-1" aria-label="Scroll categories back">${LEFT}</button>
            <button class="icon" type="button" data-scroll="cats" data-d="1" aria-label="Scroll categories forward">${RIGHT}</button>
          </div></div>
        <div class="row row--cats" id="cats">${cats.map(([g, t, src, w, h]) => `<a class="cat" href="#/shop/${g}"><div class="cat__img">${img(src, '', w, h)}</div><span>${t}</span></a>`).join('')}</div>
      </section>

      <section class="pg" aria-labelledby="cuts-t">
        ${bar('04', 'Two leggings, two cuts', pn(4))}
        <div class="section__head"><div>${hl('Two leggings', 'two cuts', 'cuts-t')}<p class="sub">Pick your fit first, then your colour.</p></div></div>
        <div class="cuts">
          <a class="cut" href="#/shop/cloud">
            <div class="cut__img">${img(shot(liveOf(cloud)[0]).src, 'High Waisted Cloud Leggings, front', 1000, 1250)}</div>
            <div class="cut__text">
              <span class="fur">${EYES}Cut 1</span>
              <h3>High Waisted Cloud Leggings</h3>
              <p>A higher waist than the Original cut, and extra comfortable.</p>
              <p class="cut__meta num">${liveOf(cloud).length} colours · ${priceRange(cloud)}</p>
              <span class="btn">Shop the Cloud cut</span>
            </div>
          </a>
          <a class="cut" href="#/shop/highwaist">
            <div class="cut__img">${img(shot(liveOf(hw)[0]).src, 'Original Cut Leggings, front', 1000, 1250)}</div>
            <div class="cut__text">
              <span class="fur">${EYES}Cut 2</span>
              <h3>Original Cut Leggings</h3>
              <p>High-waisted, body-shaping and comfortable.</p>
              <p class="cut__meta num">${liveOf(hw).length} colours · ${priceRange(hw)}</p>
              <span class="btn">Shop the Original cut</span>
            </div>
          </a>
        </div>
      </section>

      <!-- Style it hidden 18 Sep until it is right: styleStage()/stylePage() are kept -->

      <section class="pg" aria-labelledby="ig-t">
        ${bar('05', 'Seen on Instagram', pn(5))}
        <div class="section__head">
          <div>${hl('On', '@fomo.fits', 'ig-t')}<p class="sub">Real posts from our Instagram. <a class="textlink" href="https://www.instagram.com/fomo.fits/" target="_blank" rel="noopener">Follow @fomo.fits</a></p></div>
        </div>
        <div class="row row--ig" id="ig" aria-label="Photos from our Instagram">${IG_POSTS.map(([code]) => `<span class="ig">${img(`${window.A_}img--ig--${code}.webp`, 'Photo from @fomo.fits on Instagram', 600, 750)}</span>`).join('')}</div>
      </section>

      ${sets.length ? `<section class="band band--sets" aria-labelledby="sets-t">
        <div class="band__head">
          <div><span class="fur">${EYES}Matching sets</span>${hl('Jacket and leggings', 'in one colour', 'sets-t')}</div>
          <p class="band__note">Fitted Zip Jacket + Original Cut Leggings${SET_SAVE ? ` · Save ${SET_SAVE} JOD when you take both` : ''}</p>
          <a class="btn" href="#/sets">See the sets</a>
        </div>
        <div class="row row--sets" id="sets-row">${sets.join('')}</div>
      </section>` : ''}

      ${almost.length ? `<section class="pg" aria-labelledby="almost-t">
        ${bar('06', 'Almost gone', pn(6))}
        <div class="section__head">
          ${hl('Almost', 'gone', 'almost-t')}
          <div class="arrows">
            <button class="icon" type="button" data-scroll="almost" data-d="-1" aria-label="Scroll almost gone back">${LEFT}</button>
            <button class="icon" type="button" data-scroll="almost" data-d="1" aria-label="Scroll almost gone forward">${RIGHT}</button>
          </div>
        </div>
        <div class="row" id="almost">${almost.map(card).join('')}</div>
      </section>` : ''}

      <section class="brand chapter brand--short" aria-label="About FOMOFITS">
        ${corner}
        ${bar('07', 'FOMO — the fear of missing out', pn(7))}
        <div class="brand__body">
          <span class="brand__logo">${B.logoStack}</span>
          <div class="brand__text">
            <p class="brand__tag"><span class="thin">FOMO made me</span> <span class="bold">uplift</span></p>
            <p>Born in Jordan, made for the world. FOMOFITS was founded in Jordan in 2022 to build a local brand that meets global standards.</p>
            <div class="hero__btns"><a class="btn btn--light" href="#/shop/new">Shop the new collection</a><a class="textlink textlink--light" href="#/about">About FOMOFITS</a></div>
          </div>
        </div>
        ${credit}
      </section>

      <section class="pg" aria-labelledby="faq-t">
        ${bar('08', 'Before you order', pn(8))}
        <div class="faq">
          <div>${hl('Before you', 'order', 'faq-t')}</div>
          <div class="faq__list">
            <details><summary>How do I pay?</summary><p>Cash or CliQ when your order arrives, not before. Nothing is paid online.</p></details>
            <details><summary>When will it arrive?</summary><p>Amman: same day for orders before 4 pm. Other cities in Jordan: 1–2 working days. Delivery is JOD 3 in Amman, JOD 5 in other cities, and free over ${FREE_FROM} JOD.</p></details>
            <details><summary>What if the size is wrong?</summary><p>Exchange within 3 days of delivery, unworn with all tags attached. The delivery fee applies, and a price difference is paid when the new piece arrives. <a class="textlink" href="#/exchange">Start an exchange</a></p></details>
          </div>
        </div>
      </section>

      <section class="final" aria-labelledby="final-t">
        ${hl('Own your', 'FOMO', 'final-t')}
        <div class="hero__btns"><a class="btn" href="#/shop/new">Shop the new collection</a><a class="btn btn--ghost" href="#/shop/all">Shop all pieces</a></div>
      </section>

      `;
  }

  const isLeg = (g) => ['leggings', 'cloud', 'highwaist'].includes(g);
  function filtered(base) {
    const want = F.size || (F.mine ? S.pref : null);
    const out = base.filter((c) => (!F.fam || c.family === F.fam) && (!want || c.avail.some((v) => v.size === want)));
    if (F.sort === 'low') return [...out].sort((a, b) => a.price - b.price);
    if (F.sort === 'high') return [...out].sort((a, b) => b.price - a.price);
    return [...interleave(out.filter((c) => c.new)), ...interleave(out.filter((c) => !c.new))];
  }
  // one "wear it with" door inside the grid: leggings and flares point to tops, tops and jackets to leggings
  function wearTile(g) {
    const toTops = ['leggings', 'cloud', 'highwaist', 'flares'].includes(g);
    if (!toTops && !['tops', 'jackets'].includes(g)) return '';
    const [href, src, t] = toTops ? ['#/shop/tops', (window.A_ + 'img--amman-151352.webp'), 'Tops'] : ['#/shop/leggings', (window.A_ + 'img--amman-160604.webp'), 'Leggings'];
    return `<a class="wear" href="${href}"><div class="wear__img">${img(src, '', 1200, 1600)}</div><div class="wear__text"><span class="eyebrow">Wear it with</span><b>${t}</b><span class="textlink">Shop ${t.toLowerCase()}</span></div></a>`;
  }
  function results(g) {
    const items = filtered(live.filter(GROUPS[g].pick));
    if (!items.length) return { n: 0, html: `<div class="empty"><p>Nothing here${F.size ? ` in size ${F.size}` : ''}${F.fam ? ` in ${FAMS[F.fam].toLowerCase()}` : ''} right now.</p><button class="btn btn--ghost" type="button" data-fclear>Clear filters</button></div>` };
    if (g === 'leggings') {
      const html = Object.entries(CUTS).map(([id, cut]) => {
        const its = items.filter((c) => c.line.id === id);
        if (!its.length) return '';
        return `<section class="cutsec" aria-label="${cut.name}">
          <div class="cutsec__head"><div><h2>${cut.name} · ${esc(lineById(id).name)}</h2><p>${esc(cut.line)}</p></div><a class="textlink" href="#/shop/${cut.group}">Only this cut</a></div>
          <div class="grid">${its.map(card).join('')}</div>
        </section>`;
      }).join('');
      return { n: items.length, html: `${html}<div class="grid grid--tail">${wearTile(g)}</div>` };
    }
    if (g === 'new') {
      // 20 Sep, his call: New in shows each product line as its own sliding row (the tank tops and the wrap tops apart)
      const order = ['fomo-cloud-leggings', 'cloud-wrap-up', 'ribbed-tank-yop', 'highwaisted-flare'];
      const lines = [...new Set(items.map((c) => c.line.id))].sort((x, y) => (order.indexOf(x) + 1 || 99) - (order.indexOf(y) + 1 || 99));
      const html = lines.map((id) => {
        const its = items.filter((c) => c.line.id === id);
        const l = its[0].line; const k = groupOf(its[0]);
        return `<section class="cutsec cutsec--row" aria-label="${esc(l.name)}">
          <div class="cutsec__head"><h2>${esc(l.name)}</h2><div class="arrows">
            <button class="icon" type="button" data-scroll="new-${id}" data-d="-1" aria-label="Scroll ${esc(l.name)} back">${LEFT}</button>
            <button class="icon" type="button" data-scroll="new-${id}" data-d="1" aria-label="Scroll ${esc(l.name)} forward">${RIGHT}</button>
            <a class="textlink" href="#/shop/${k}">See all ${GROUPS[k].title.toLowerCase()}</a></div></div>
          <div class="row row--shop" id="new-${id}">${its.map(card).join('')}</div>
        </section>`;
      }).join('');
      return { n: items.length, html };
    }
    const cards = items.map(card);
    if (cards.length > 4) cards.splice(3, 0, wearTile(g));
    return { n: items.length, html: `<div class="grid">${cards.join('')}</div>` };
  }
  function shop(group, query = '') {
    const g = GROUPS[group] ? group : 'all';
    if (F.g !== g) { F.g = g; F.fam = null; F.sort = 'new'; F.size = null; F.mine = false; }
    if (query) {                                  // she opened a link that already carries filters
      const q = new URLSearchParams(query.slice(1));
      F.size = q.get('size') || null;
      F.fam = q.get('colour') || null;
      F.sort = q.get('sort') || 'new';
      F.mine = q.get('mine') === '1';
    }
    const base = live.filter(GROUPS[g].pick);
    const tabOn = isLeg(g) ? 'leggings' : g;
    const tabs = Object.entries(GROUPS).filter(([, x]) => !x.hidden).map(([id, x]) => `<a href="#/shop/${id}" ${id === tabOn ? 'aria-current="page"' : ''}>${x.title}</a>`).join('');
    // 19 Sep, his call: every control in one sliding bar; no counts on the chips
    const cutChips = isLeg(g) ? [['leggings', 'Both cuts'], ['cloud', 'Cloud cut'], ['highwaist', 'Original cut']].map(([id, t]) => `<a class="fchip" href="#/shop/${id}" aria-current="${id === g ? 'page' : 'false'}">${t}</a>`).join('') : '';
    const sizes = SIZE_ORDER.filter((s) => base.some((c) => c.sizes.some((v) => v.size === s)));
    if (F.size && !sizes.includes(F.size)) F.size = null;
    const fams = Object.keys(FAMS).filter((f) => base.some((c) => c.family === f));
    const hexOf = (f) => (base.find((c) => c.family === f && c.hex) || {}).hex || '#999';
    const r = results(g);
    return `<div class="page">
      <div class="page__top">
        ${bar('', `Shop — ${GROUPS[g].title}`)}
        ${hl(GROUPS[g].hl[0], GROUPS[g].hl[1], '', 'h1')}
        <nav class="tabs" aria-label="Categories">${tabs}</nav>
      </div>
      <div class="filters">
        <div class="frow frow--all" aria-label="Filters">
          ${cutChips ? `<span class="fgroup" role="group" aria-label="Leggings cut">${cutChips}</span><i class="fsep" aria-hidden="true"></i>` : ''}
          ${sizes.length > 1 ? `<span class="fgroup" role="group" aria-label="Size"><span class="flabel">Size</span>${sizes.map((s) => `<button class="fchip" type="button" data-fsize="${s}" aria-pressed="${F.size === s}">${s}</button>`).join('')}</span><i class="fsep" aria-hidden="true"></i>` : ''}
          ${fams.length > 1 ? `<span class="fgroup" role="group" aria-label="Colour"><span class="flabel">Colour</span>${fams.map((f) => `<button class="fchip" type="button" data-fam="${f}" aria-pressed="${F.fam === f}"><i style="--c:${esc(hexOf(f))}"></i>${FAMS[f]}</button>`).join('')}</span><i class="fsep" aria-hidden="true"></i>` : ''}
          ${S.pref ? `<button class="fchip" type="button" data-fmine aria-pressed="${F.mine}">In my size · ${S.pref}</button>` : ''}
          ${F.fam || F.size || F.mine ? '<button class="linkish" type="button" data-fclear>Clear filters</button>' : ''}
          <label class="fsort"><span>Sort</span><select id="sort"><option value="new" ${F.sort === 'new' ? 'selected' : ''}>New first</option><option value="low" ${F.sort === 'low' ? 'selected' : ''}>Price: low to high</option><option value="high" ${F.sort === 'high' ? 'selected' : ''}>Price: high to low</option></select></label>
        </div>
        <p class="count sr-only" aria-live="polite">${r.n} ${r.n === 1 ? 'piece' : 'pieces'}</p>
      </div>
      <div id="results" data-g="${g}">${r.html}</div>
      ${soldOutRow(g)}
      ${seenRow()}
    </div>`;
  }
  // keep the link in step with the filters, without adding a history entry for every tap
  function syncFilterUrl() {
    if (!F.g) return;
    const q = new URLSearchParams();
    if (F.size) q.set('size', F.size);
    if (F.fam) q.set('colour', F.fam);
    if (F.sort !== 'new') q.set('sort', F.sort);
    if (F.mine) q.set('mine', '1');
    const s2 = q.toString();
    history.replaceState(null, '', `#/shop/${F.g}${s2 ? `?${s2}` : ''}`);
  }
  // sold out right now: shown, not hidden, so she can ask about a restock instead of thinking it never existed
  function soldOutRow(g) {
    const gone = all.filter((c) => c.soldOut && GROUPS[g].pick(c));
    if (!gone.length) return '';
    return `<section class="pg pg--flat" aria-labelledby="gone-t">
      ${bar('', 'Sold out right now', `${gone.length} ${gone.length === 1 ? 'piece' : 'pieces'}`)}
      <div class="section__head"><div>${hl('Sold', 'out', 'gone-t')}<p class="sub">Message us on Instagram and we'll tell you when it's back.</p></div>
      <a class="textlink" href="https://ig.me/m/fomo.fits" target="_blank" rel="noopener">DM @fomo.fits</a></div>
      <div class="grid grid--gone">${gone.map(card).join('')}</div>
    </section>`;
  }
  // the pieces she looked at, ready to pick up again
  function seenRow() {
    const seen = S.seen.map((k) => byKey.get(k)).filter((c) => c && !c.soldOut).slice(0, 8);
    return seen.length >= 2 ? row('seen', 'You looked at', seen, null) : '';
  }
  function refilter() {
    syncFilterUrl();
    const box = $('#results'); if (!box) return;
    const r = results(box.dataset.g);
    box.innerHTML = r.html;
    $('.filters .count').textContent = `${r.n} ${r.n === 1 ? 'piece' : 'pieces'}`;
    $$('[data-fsize]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.fsize === F.size)));
    $$('[data-fam]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.fam === F.fam)));
    const mine = $('[data-fmine]'); if (mine) mine.setAttribute('aria-pressed', String(F.mine));
    const on = !!(F.fam || F.size || F.mine);
    const clear = $('[data-fclear]');
    if (on && !clear) { const b = document.createElement('button'); b.className = 'linkish'; b.type = 'button'; b.dataset.fclear = ''; b.textContent = 'Clear filters'; const bar = $('.frow--all'); if (bar) bar.insertBefore(b, $('.frow--all .fsort')); }
    if (!on && clear) clear.remove();
    reveal(box);
  }

  // when her size (or the whole piece) is gone, let her ask for it instead of leaving
  function backNote(c) {
    const sz = S.pref;
    const gone = c.soldOut || (sz && c.sizes.some((v) => v.size === sz) && !c.avail.some((v) => v.size === sz));
    if (!gone) return '';
    // send her to the colours of this piece that still have her size, before asking her to wait
    const still = sz ? c.line.colours.filter((x) => x.key !== c.key && x.avail.some((v) => v.size === sz)) : [];
    const what = c.soldOut ? title(c) : `${title(c)} in size ${sz}`;
    return `<div class="backnote"><p><b>${c.soldOut ? 'Sold out right now.' : `Size ${esc(sz)} is sold out.`}</b>${still.length ? ` Still in ${still.slice(0, 4).map((x) => `<a href="${pHref(x.key)}">${esc(x.name)}</a>`).join(', ')}.` : ''} Or tell us and we'll message you when it's back.</p>
      <button class="btn btn--ghost" type="button" data-notify="${esc(what)}">Tell me when it's back</button></div>`;
  }
  function product(key) {
    const c = byKey.get(key);
    if (!c) return null;
    const line = c.line; const g = groupOf(c);
    S.size = prefFor(c) || null; S.pick = 1;
    S.seen = [c.key, ...S.seen.filter((k) => k !== c.key)].slice(0, 12); store.set('seen', S.seen);
    const saved = S.saved.includes(c.key);
    const look = c.soldOut ? [] : goesWith(c, 2);
    const skip = new Set([c.key, ...look.map((x) => x.key)]);
    const other = line.mix === 'top' ? 'bottom' : line.mix === 'bottom' ? 'top' : null;
    const pairs = (other ? live.filter((x) => x.line.mix === other) : live.filter((x) => x.line.group === line.group && x.line !== line)).filter((x) => !skip.has(x.key));
    const seen = S.seen.filter((k) => k !== c.key).map((k) => byKey.get(k)).filter((x) => x && !x.soldOut).slice(0, 8);
    const status = c.soldOut ? '' : c.lastSize ? `Only ${c.avail[0].size} left` : c.avail.length < c.sizes.length ? `${c.avail.map((v) => v.size).join(', ')} available` : '';
    const hint = S.size ? `Size ${S.size}, the size you chose last time.` : 'Not sure? Take the size you usually wear.';
    // leggings: switch cut and keep the colour when the other cut has it
    let cutSwitch = '';
    if (CUTS[line.id]) {
      cutSwitch = `<div class="opt"><span class="opt__label">Cut</span><div class="seg" role="group" aria-label="Cut">${Object.keys(CUTS).map((id) => {
        const l = lineById(id);
        const to = id === line.id ? c : l.colours.find((x) => !x.soldOut && sameName(x.name, c.name)) || l.colours.find((x) => !x.soldOut);
        return to ? `<a href="${pHref(to.key)}" aria-current="${id === line.id}">${CUTS[id].name}</a>` : '';
      }).join('')}</div></div>`;
    }
    const set = OFFER_SETS[0];
    const setNote = set && set.lines.includes(line.id) && !c.soldOut
      ? `<p class="setnote">Part of <b>${set.name}</b>: take ${line.id === 'fomo-leggings' ? 'a Fitted Zip Jacket' : 'the Original Cut Leggings'} too and save ${set.off} JOD.</p>` : '';
    return `
      <nav class="crumbs" aria-label="Breadcrumb">
        <span><a href="#/">Home</a> / <a href="#/shop/${g}">${GROUPS[g].title}</a> / ${esc(line.name)}</span>
        ${(() => {                                   // move through this category without going back to the grid
    const list = live.filter(GROUPS[g].pick);
    const i = list.findIndex((x) => x.key === c.key);
    if (i < 0 || list.length < 2) return '';
    const prev = list[(i - 1 + list.length) % list.length]; const next = list[(i + 1) % list.length];
    return `<span class="crumbs__steps">
          <a href="${pHref(prev.key)}" aria-label="Previous piece: ${esc(title(prev))}">${LEFT}</a>
          <span class="num">${i + 1} / ${list.length}</span>
          <a href="${pHref(next.key)}" aria-label="Next piece: ${esc(title(next))}">${RIGHT}</a>
        </span>`;
  })()}
      </nav>
      <div class="pdp">
        <div class="shotwrap">
          <div class="shots" id="shots" aria-label="Photos">${c.images.map((im, i) => `<button class="shot" type="button" data-zoom="${i}" aria-label="Open photo ${i + 1} of ${c.images.length} full screen">${img(im.src, i ? '' : title(c), im.w, im.h, i === 0).replace('<img ', i === 0 ? '<img class="shot0" ' : '<img ')}</button>`).join('')}</div>
          ${c.images.length > 1 ? `<p class="shots__n num" aria-hidden="true"><span id="shotN">1</span> / ${c.images.length}</p>` : ''}
        </div>
        <div class="buy">
          <div class="buy__head">
            <span class="fur">${EYES}${c.almost ? 'Almost gone' : c.new ? 'New collection' : GROUPS[g].title}${CUTS[line.id] ? ` · ${CUTS[line.id].name}` : ''}</span>
            <h1>${esc(line.name)}</h1>
            <p class="buy__price num">${priceTag(c)}</p>
            ${c.was ? `<p class="buy__off">Sale · ${Math.round((1 - c.price / c.was) * 100)}% off</p>` : ''}
          </div>
          ${line.tagline ? `<p class="buy__tag">${esc(line.tagline)}</p>` : ''}
          ${cutSwitch}
          ${line.colours.length > 1 || c.name ? `<div class="opt">
            <span class="opt__label">Colour: <b>${esc(c.name)}</b></span>
            ${line.colours.length > 1 ? `<div class="colours">${line.colours.map((x) => `<a href="${pHref(x.key)}" class="${x.soldOut ? 'out' : ''}" aria-current="${x.key === c.key}" aria-label="${esc(x.name)}${x.soldOut ? ' (sold out)' : ''}" title="${esc(x.name)}">${line.group === 'essentials' ? `<span style="position:absolute;inset:0;background:${esc(x.hex || '#ccc')}"></span>` : img(x.images[0].src, '', x.images[0].w, x.images[0].h)}</a>`).join('')}</div>` : ''}
          </div>` : ''}
          ${c.sizes.length ? `<div class="opt">
            <span class="opt__label" id="sizeLabel">Size</span>
            <div class="sizes" role="group" aria-labelledby="sizeLabel">${c.sizes.map((v) => `<button type="button" class="size" data-size="${v.size}" aria-pressed="${v.size === S.size}" ${v.available ? '' : 'disabled'} aria-label="${v.size}${v.available ? '' : ', sold out'}">${v.size}</button>`).join('')}</div>
            <p class="hint" id="sizeHint">${esc(hint)}</p>${status ? `<p class="hint hint--stock">${esc(status)}</p>` : ''}
          </div>` : ''}
          <div class="buy__actions">
            ${c.soldOut ? '' : `<div class="qty qty--buy" role="group" aria-label="Quantity"><button type="button" data-pq="-1" aria-label="One less">−</button><output class="num" id="pickN">1</output><button type="button" data-pq="1" aria-label="One more">+</button></div>`}
            <button class="btn" type="button" data-add="${esc(c.key)}" ${c.soldOut ? 'disabled' : ''}>${c.soldOut ? 'Sold out' : 'Add to bag'}</button>
            <button class="save" type="button" data-save="${esc(c.key)}" aria-pressed="${saved}" aria-label="${saved ? 'Remove from saved' : 'Save'}">${HEART}</button>
            <button class="save" type="button" data-share="${esc(c.key)}" aria-label="Share this piece">${SHARE}</button>
          </div>
          ${c.soldOut ? '' : '<p class="assure">Cash or CliQ on delivery · Same day in Amman · Exchange within 3 days</p>'}
          ${c.soldOut ? '' : `<button class="btn btn--ghost btn--wide" type="button" data-buynow="${esc(c.key)}">Buy now · skip the bag</button>`}
          ${backNote(c)}
          ${setNote}
          <ul class="perks">
            <li>Cash or CliQ on delivery</li>
            <li>Same day in Amman (order before 4 pm), 1–2 working days in other cities in Jordan</li>
            <li>Free delivery over ${FREE_FROM} JOD</li>
            <li>Exchange within 3 days</li>
          </ul>
          ${look.length ? `<div class="ctl"><h2 class="ctl__h">Complete the look</h2>${look.map((x) => mini(x)).join('')}</div>` : ''}
          <div>
            <details><summary>Delivery</summary><p>Amman: same day for orders before 4 pm, JOD 3. Other cities in Jordan: 1–2 working days, JOD 5. Free on orders over ${FREE_FROM} JOD. Pay by cash or CliQ when your order arrives.</p></details>
            <details><summary>Exchange</summary><p>Exchange within 3 days of delivery. Items must be unworn with all tags attached, and delivery fees apply. We don't offer returns. <a class="textlink" href="#/exchange">Start an exchange</a></p></details>
            <details><summary>Questions</summary><p>Message us on Instagram for sizing or anything else. <a class="textlink" href="https://ig.me/m/fomo.fits" target="_blank" rel="noopener">DM @fomo.fits</a></p></details>
          </div>
        </div>
      </div>
      ${row('pairs', 'Wear it with', pairs.slice(0, 10), null)}
      ${row('seen', 'You looked at', seen, null)}
      ${c.soldOut ? '' : `<div class="stickybuy"><button class="btn" type="button" data-add="${esc(c.key)}">Add to bag · ${money(c.almost ? agPrice(c) : c.price)}</button></div>`}`;
  }

  /* ---------------- motion ---------------- */
  const calm = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // cards and sections ease up as they enter the screen (CSS scroll timeline; everything is already visible without it)
  function reveal(root = document) {
    $$('.grid > .pc, .grid > .wear, .cut, .cat, .look, .cutsec__head, .section__head, .brand__body, .chapter__body, .ig a', root).forEach((el) => el.classList.add('rv'));
  }
  // a small pop on the bag icon when something goes in
  function bump() {
    if (calm()) return;
    const el = $('.head [data-open="bag"]');
    el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(.96)' }, { transform: 'scale(1)' }], { duration: 520, easing: 'cubic-bezier(.3,.7,.3,1)' });
  }

  /* the logo motion from the brand's own clip (Company/Logo motion): F between two ✕, the letter turns F → O → M → O,
     then the four letters settle into the main logo and the eyes land on the Ö. Once per visit; tap to skip. */
  /* intro sound + vibration: made in code (Web Audio), low and short; nothing is downloaded.
     Phones only allow sound and vibration after a touch, and iPhones follow the silent switch. */
  let INTRO_LOG = [];
  function sfx() {
    const log = [];
    const AC = window.AudioContext || window.webkitAudioContext;
    let ctx = null;
    try { ctx = AC ? new AC() : null; } catch (e) { ctx = null; }
    let master = null;
    if (ctx) { master = ctx.createGain(); master.gain.value = 0.55; master.connect(ctx.destination); }
    // iPhone (iOS 18+) gives a light tap when a switch toggles; Android uses navigator.vibrate
    // (made up front: iPhones only give the tap when the click comes straight from her finger)
    let sw = document.getElementById('hapt');
    if (!sw) {
      sw = document.createElement('label'); sw.id = 'hapt'; sw.className = 'vh'; sw.setAttribute('aria-hidden', 'true');
      sw.innerHTML = '<input type="checkbox" switch tabindex="-1">';
      document.body.appendChild(sw);
    }
    const buzz = (ms) => {
      try {
        if (navigator.userActivation && !navigator.userActivation.hasBeenActive) return;
        if (navigator.vibrate) { navigator.vibrate(ms); return; }
        sw.click();
      } catch (e) { /* no haptics here */ }
    };
    const noise = (dur) => {
      const b = ctx.createBuffer(1, Math.ceil(ctx.sampleRate * dur), ctx.sampleRate);
      const d = b.getChannelData(0);
      for (let i = 0; i < d.length; i += 1) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length);
      const n = ctx.createBufferSource(); n.buffer = b; return n;
    };
    const env = (g, t, peak, dur) => { g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(peak, t + 0.004); g.gain.exponentialRampToValueAtTime(0.0001, t + dur); };
    const SOUNDS = {
      click(t) {   // a soft shutter-like click
        const n = noise(0.05); const f = ctx.createBiquadFilter(); f.type = 'bandpass'; f.frequency.value = 1900; f.Q.value = 1.2;
        const g = ctx.createGain(); env(g, t, 0.35, 0.045); n.connect(f).connect(g).connect(master); n.start(t); n.stop(t + 0.06);
        const o = ctx.createOscillator(); o.type = 'sine'; o.frequency.setValueAtTime(220, t); o.frequency.exponentialRampToValueAtTime(90, t + 0.06);
        const g2 = ctx.createGain(); env(g2, t, 0.25, 0.07); o.connect(g2).connect(master); o.start(t); o.stop(t + 0.08);
      },
      tick(t) {    // the eyes: a tiny, higher click
        const n = noise(0.03); const f = ctx.createBiquadFilter(); f.type = 'highpass'; f.frequency.value = 2600;
        const g = ctx.createGain(); env(g, t, 0.16, 0.025); n.connect(f).connect(g).connect(master); n.start(t); n.stop(t + 0.035);
      },
      thump(t) {   // the logo lands: a deep, short bass hit
        const o = ctx.createOscillator(); o.type = 'sine'; o.frequency.setValueAtTime(92, t); o.frequency.exponentialRampToValueAtTime(38, t + 0.35);
        const g = ctx.createGain(); env(g, t, 0.95, 0.5); o.connect(g).connect(master); o.start(t); o.stop(t + 0.55);
        const n = noise(0.08); const f = ctx.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = 420;
        const g2 = ctx.createGain(); env(g2, t, 0.4, 0.09); n.connect(f).connect(g2).connect(master); n.start(t); n.stop(t + 0.1);
      },
      whoosh(t) {  // the page lifts: a quiet low air sweep
        const n = noise(0.6); const f = ctx.createBiquadFilter(); f.type = 'bandpass'; f.Q.value = 0.8;
        f.frequency.setValueAtTime(260, t); f.frequency.exponentialRampToValueAtTime(1400, t + 0.55);
        const g = ctx.createGain(); g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.12, t + 0.25); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.6);
        n.connect(f).connect(g).connect(master); n.start(t); n.stop(t + 0.62);
      },
    };
    const HAPTIC = { click: 14, tick: 8, thump: 70, whoosh: 0 };
    return {
      log,
      state: () => (ctx ? ctx.state : 'none'),
      buzz,
      ready: () => !!ctx && ctx.state === 'running',
      resume: () => (ctx && ctx.state !== 'running' ? ctx.resume().catch(() => {}) : Promise.resolve()),
      unlock: () => { if (ctx && ctx.state !== 'running') { try { const b = ctx.createBufferSource(); b.buffer = ctx.createBuffer(1, 1, 22050); b.connect(ctx.destination); b.start(0); } catch (e) { /* ignore */ } } },
      play(kind) {
        log.push(kind);
        if (ctx && ctx.state === 'running') { try { SOUNDS[kind](ctx.currentTime + 0.005); } catch (e) { /* ignore */ } }
        if (HAPTIC[kind]) buzz(HAPTIC[kind]);
      },
    };
  }

  /* The intro (his calls, 19 Sep audit): home page only, never on a product link from Instagram; once per phone or
     laptop, not once per tab; about 1.2 s instead of 2.0; silent unless she presses "Play the FOMO intro";
     with Reduce Motion on, a 300 ms fade at most. ?intro replays it. */
  function intro(replay = false) {
    const el = $('#intro');
    let seen = false; try { seen = !!(localStorage.getItem('fomo2.introSeen') || sessionStorage.getItem('fomo2.intro')); } catch (e) { /* no storage */ }
    const force = /[?&]intro\b/.test(location.search);
    const home = here() === '' || here() === '#/';
    if (!el || (!replay && !force && (seen || !home))) return;
    try { localStorage.setItem('fomo2.introSeen', '1'); sessionStorage.setItem('fomo2.intro', '1'); } catch (e) { /* no storage */ }
    const P = B.mainParts;
    if (calm() && !replay) {
      // Reduce Motion on (common on iPhones): still greet her with the logo, but only a short fade, nothing moves
      el.innerHTML = `<svg class="intro__logo" viewBox="${B.mainVB}" fill="currentColor" aria-hidden="true">${['f', 'o1', 'm', 'o2', 'e1', 'e2'].map((k) => `<path d="${P[k]}"/>`).join('')}</svg>`;
      el.hidden = false; document.documentElement.classList.add('intro-on');
      const fade = el.animate([{ opacity: 1 }, { opacity: 1, offset: 0.4 }, { opacity: 0 }], { duration: 300, easing: 'ease-in', fill: 'forwards' });
      const done = () => { el.hidden = true; el.innerHTML = ''; el.getAnimations().forEach((a) => a.cancel()); document.documentElement.classList.remove('intro-on'); };
      fade.finished.then(done, done);
      return;
    }
    el.innerHTML = `<svg class="intro__logo" viewBox="${B.mainVB}" fill="currentColor" aria-hidden="true">${['f', 'o1', 'm', 'o2', 'e1', 'e2'].map((k) => `<path class="p-${k}" d="${P[k]}"/>`).join('')}</svg>`;
    el.hidden = false;
    delete el.dataset.touched;
    document.documentElement.classList.add('intro-on');
    const T = 2300; const at = (ms) => Math.min(1, ms / T);
    const CX = 960.2; const CY = 539.8;
    const mid = { f: [916.7, 492.25], m: [916.7, 628.05], o1: [1003.2, 492.6], o2: [1003.2, 628], e1: [978.95, 401.85], e2: [1027.4, 401.85] };
    const tf = (k, dx = 0, dy = 0, s = 1, r = 0, sy = 1) => `translate(${dx}px, ${dy}px) rotate(${r}deg) scale(${s}, ${s * sy})`;
    const centred = (k, s, y = 0, sy = 1) => tf(k, CX - mid[k][0], CY - mid[k][1] + y, s, 0, sy);
    const home0 = tf('x');
    const EASE = 'cubic-bezier(.2,.8,.2,1)';
    const A = 1400; const Z = 1950; // assemble window
    // the letter cycle: [key, in, out]
    [['f', 0, 520], ['o1', 520, 800], ['m', 800, 1080]].forEach(([k, t0, t1]) => {
      $(`.p-${k}`, el).animate([
        { offset: 0, opacity: 0, transform: centred(k, 1.7, -30, 1.25) },
        ...(t0 ? [{ offset: at(t0), opacity: 0, transform: centred(k, 1.7, -30, 1.25) }] : []),
        { offset: at(t0 + 160), opacity: 1, transform: centred(k, 1.7), easing: EASE },
        { offset: at(t1), opacity: 1, transform: centred(k, 1.7) },
        { offset: at(t1 + 120), opacity: 0, transform: centred(k, 1.7, 36, 1.25) },
        { offset: at(A), opacity: 0, transform: centred(k, .6), easing: EASE },
        { offset: at(Z), opacity: 1, transform: home0 },
        { offset: 1, opacity: 1, transform: home0 },
      ], { duration: T, fill: 'both' });
    });
    $('.p-o2', el).animate([
      { offset: 0, opacity: 0, transform: centred('o2', 1.7, -30, 1.25) },
      { offset: at(1080), opacity: 0, transform: centred('o2', 1.7, -30, 1.25) },
      { offset: at(1240), opacity: 1, transform: centred('o2', 1.7), easing: EASE },
      { offset: at(A), opacity: 1, transform: centred('o2', 1.7), easing: EASE },
      { offset: at(Z), opacity: 1, transform: home0 },
      { offset: 1, opacity: 1, transform: home0 },
    ], { duration: T, fill: 'both' });
    // the eyes land, then the right one winks once (his ask, 20 Sep) before the curtain lifts
    const T2 = T + 620; const at2 = (ms) => Math.min(1, ms / T2);
    [['e1', -1], ['e2', 1]].forEach(([k, side]) => {
      const flank = (r) => tf(k, CX + side * 104 - mid[k][0], CY - mid[k][1], 1, r);
      const home = tf(k, 0, 0, 1, 180); const shut = tf(k, 0, 0, 1, 180, .08);
      $(`.p-${k}`, el).animate([
        { offset: 0, opacity: 0, transform: flank(-90) },
        { offset: at2(260), opacity: 0, transform: flank(-90), easing: EASE },
        { offset: at2(480), opacity: 1, transform: flank(0) },
        { offset: at2(A), opacity: 1, transform: flank(0), easing: EASE },
        { offset: at2(Z + 120), opacity: 1, transform: home },
        ...(k === 'e2' ? [
          { offset: at2(Z + 300), opacity: 1, transform: home, easing: 'ease-in' },
          { offset: at2(Z + 390), opacity: 1, transform: shut },
          { offset: at2(Z + 720), opacity: 1, transform: shut, easing: 'ease-out' },
          { offset: at2(Z + 860), opacity: 1, transform: home },
        ] : []),
        { offset: 1, opacity: 1, transform: home },
      ], { duration: T2, fill: 'both' });
    });
    const lift = el.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(-100%)' }], { delay: T2 + 120, duration: 600, easing: 'cubic-bezier(.7,0,.2,1)', fill: 'forwards' });
    // 20 Sep, his call ("too fast" at 1.2 s): about 2 s, the pace he approved on 18 Sep; it still plays once per device, on the home only
    const SPEED = 1.5;
    el.getAnimations({ subtree: true }).forEach((x) => { x.playbackRate = SPEED; });
    const SOUND = replay || /[?&]sound\b/.test(location.search);   // silent by default; the footer's replay button plays the cues
    // sound + vibration on the same clock as the letters (ms from the start)
    const CUES = [[120, 'click'], [400, 'tick'], [450, 'tick'], [600, 'click'], [880, 'click'], [1160, 'click'], [1950, 'thump'], [2070, 'tick'], [2120, 'tick'], [T + 150, 'whoosh']];
    const t0 = performance.now();
    const S2 = sfx();
    const timers = [];
    const arm = (from) => CUES.forEach(([t0c, kind]) => { const t = t0c / SPEED; if (t >= from) timers.push(setTimeout(() => S2.play(kind), Math.max(0, t - (performance.now() - t0)))); });
    let live2 = false;
    const start = () => { if (!SOUND) return true; if (live2) return true; if (!S2.ready()) return false; live2 = true; arm(performance.now() - t0 - 30); return true; };
    if (SOUND && !start()) S2.resume().then(() => start());   // allowed straight away on some browsers; otherwise wait for her first touch
    const LIFT = ['touchend', 'pointerup', 'click', 'keydown'];
    const done = () => { el.hidden = true; el.innerHTML = ''; document.documentElement.classList.remove('intro-on'); timers.forEach(clearTimeout); LIFT.forEach((t) => document.removeEventListener(t, unlock, true)); };
    lift.finished.then(done, done);
    const skip = () => el.getAnimations({ subtree: true }).forEach((x) => { try { x.finish(); } catch (e) { /* already done */ } });
    // her first touch turns sound and vibration on (phones require it) and the intro keeps playing; a second tap skips
    // iPhones only allow sound when the finger lifts (touchend / click), not when it lands
    let tapped = false;
    function unlock() {
      if (!SOUND) return;
      S2.unlock();
      if (!tapped) { tapped = true; S2.buzz(14); }
      S2.resume().then(() => start());
    }
    if (SOUND) LIFT.forEach((t) => document.addEventListener(t, unlock, true));
    if (replay) { tapped = true; S2.unlock(); S2.buzz(14); }
    el.addEventListener('click', () => { if (el.dataset.touched) skip(); el.dataset.touched = '1'; });
    document.addEventListener('keydown', skip, { once: true });
    INTRO_LOG = S2.log;
    if (/[?&]debug\b/.test(location.search)) {   // ?debug shows what a phone allows (audio state, vibration, cues)
      const dbg = document.createElement('pre');
      dbg.style.cssText = 'position:fixed;z-index:300;left:8px;bottom:8px;margin:0;padding:8px;background:#fff;color:#000;font:12px/1.3 monospace;max-width:90vw;white-space:pre-wrap';
      document.body.appendChild(dbg);
      const tick = () => { dbg.textContent = `audio: ${S2.state()}\nvibrate api: ${'vibrate' in navigator}\nactivated: ${navigator.userActivation ? navigator.userActivation.hasBeenActive : 'n/a'}\ncues: ${S2.log.join(' ')}`; };
      setInterval(tick, 200); tick();
    }
  }

  /* ---------------- router ---------------- */
  /* 19 Sep, for Google: on the live shop a product has its real address (/products/<handle>, ?c=<colour> for pieces
     that share one Shopify product), everything else stays a #/ page. here() turns either into one route string. */
  function pHref(key) {
    if (!window.A_) return `#/p/${encodeURIComponent(key)}`;
    const c = byKey.get(key); const [h, col] = String(key).split('~');
    return `/products/${(c && c.handle) || h}${col ? `?c=${encodeURIComponent(col)}` : ''}`;
  }
  function here() {
    const h = decodeURIComponent(location.hash || '');
    if (h.startsWith('#/')) return h;
    const m = window.A_ && location.pathname.match(/^\/products\/([^/?#]+)/);
    if (m) {
      const handle = decodeURIComponent(m[1]); const col = new URLSearchParams(location.search).get('c');
      const key = col ? `${handle}~${col}` : byKey.has(handle) ? handle : (live.find((c) => c.handle === handle) || { key: handle }).key;
      return `#/p/${key}`;
    }
    if (window.FOMO_POLICY && location.pathname.startsWith('/policies/')) return '#/policy';
    return h;
  }
  function go(href) {
    if (window.A_ && (href.startsWith('/products/') || (href.startsWith('#/') && location.pathname !== '/'))) {
      history.pushState(null, '', href.startsWith('#') ? `/${href}` : href); onNav(); return;
    }
    location.hash = href;
  }
  let lastHere = null;
  const onNav = () => { if (here() !== lastHere) route(); };
  let shared = null;   // the card photo that grows into the product photo
  function render() {
    const h = here(); lastHere = h;
    let m; let html = null; let docTitle = 'FOMOFITS — Lifestyle pieces born in Jordan · Same-day delivery in Amman';
    if ((m = h.match(/^#\/p\/(.+)$/))) {
      html = product(m[1]);
      const c = byKey.get(m[1]);
      if (c) docTitle = `${title(c)} | FOMOFITS`;
    } else if (h === '#/exchange') {
      html = exchangePage(); docTitle = 'Exchange an item | FOMOFITS';
    } else if (h === '#/about') {
      html = aboutPage(); docTitle = 'About | FOMOFITS';
    } else if (h === '#/help') {
      html = helpPage(); docTitle = 'Delivery and exchange | FOMOFITS';
    } else if (h === '#/policy') {
      const pp = policyPage(); html = pp.html; docTitle = `${pp.title} | FOMOFITS`;
    } else if (h === '#/style') {
      if (STYLE_ON) { html = stylePage(); docTitle = 'Style it | FOMOFITS'; } else { history.replaceState(null, '', '#/'); html = home(); }
    } else if (h === '#/sets') {
      html = setsPage(); docTitle = 'Matching sets | FOMOFITS';
    } else if ((m = h.match(/^#\/shop\/([a-z]+)(\?.*)?$/))) {
      html = shop(m[1], m[2] || ''); docTitle = `${(GROUPS[m[1]] || GROUPS.all).title} | FOMOFITS`;
    }
    if (html == null && h && h !== '#/' && h !== '#') {
      html = `<div class="pg pg--404">
        ${bar('', 'Page not found', '404')}
        <div class="lost">
          <span class="lost__face" aria-hidden="true">${B.oEyes}</span>
          ${hl('This page', 'is missing out', '', 'h1')}
          <p class="lead">The link is broken or the piece has gone. Try the new collection, or search.</p>
          <div class="hero__btns"><a class="btn" href="#/shop/new">Shop the new collection</a><button class="btn btn--ghost" type="button" data-open="search">Search</button></div>
        </div>
      </div>`;
      docTitle = 'Page not found | FOMOFITS';
    }
    if (html == null) html = home();
    const grow = !!shared; shared = null;
    const view = $('#view');
    view.innerHTML = html;
    if (grow) { const s0 = $('.shot0', view); if (s0) s0.style.viewTransitionName = 'shot'; }
    document.title = docTitle;
    setMeta(h);
    document.body.classList.toggle('has-sticky', !!$('.stickybuy', view));
    const cur = (h.match(/^#\/shop\/([a-z]+)/) || [])[1];
    const curHref = h === '#/sets' ? '#/sets' : cur ? `#/shop/${isLeg(cur) ? 'leggings' : cur}` : '';
    $$('.nav a').forEach((a) => a.setAttribute('aria-current', curHref && a.getAttribute('href') === curHref ? 'page' : 'false'));
    closeOverlay(false);
    window.scrollTo(0, 0);
    if (h) view.focus({ preventScroll: true });
    reveal(view);
    placeBuyHead();
    bindShots();
    updateArrows();
  }
  /* 19 Sep audit: on an iPhone the first screen of a product showed the photo and a pager but no name and no price
     (the name sat behind the fixed buy bar). On phones the head (eyebrow, name, price) moves above the photos; it is
     the same node, so the page keeps one h1 and the desktop column is untouched. */
  function placeBuyHead() {
    const head = $('.buy__head'); const pdp = $('.pdp'); const buy = $('.buy');
    if (!head || !pdp || !buy) return;
    const mobile = window.matchMedia('(max-width: 860px)').matches;
    if (mobile && head.parentElement !== pdp) pdp.insertBefore(head, pdp.firstElementChild);
    else if (!mobile && head.parentElement === pdp) buy.insertBefore(head, buy.firstElementChild);
  }
  let headT = 0;
  window.addEventListener('resize', () => { clearTimeout(headT); headT = setTimeout(placeBuyHead, 120); });
  // the link preview she gets when she sends a piece on Instagram or WhatsApp, plus machine-readable product data
  function setMeta(h) {
    const c = byKey.get((h.match(/^#\/p\/(.+)$/) || [])[1] || '');
    const set = (sel, attr, val) => { const el = $(sel); if (el) el.setAttribute(attr, val); };
    const abs = (u) => new URL(u, location.href).href;
    const desc = c ? `${title(c)} — ${money(c.almost ? agPrice(c) : c.price)}. ${c.line.tagline || 'Born in Jordan, made for the world.'}`
      : 'Lifestyle pieces born in Jordan, made for the world. Same day delivery in Amman, cash or CliQ on delivery, free delivery over 50 JOD.';
    set('meta[name="description"]', 'content', desc);
    // a missing page is not for search results
    let rob = $('meta[name="robots"]');
    if (h === '#/not-found' || (h && h !== '#/' && !c && !/^#\/(shop|sets|exchange|about|help|policy|style)/.test(h))) {
      if (!rob) { rob = document.createElement('meta'); rob.setAttribute('name', 'robots'); document.head.appendChild(rob); }
      rob.setAttribute('content', 'noindex');
    } else if (rob) rob.remove();
    set('meta[property="og:title"]', 'content', c ? `${title(c)} · FOMOFITS` : 'FOMOFITS — You wear to represent');
    set('meta[property="og:description"]', 'content', desc);
    set('meta[property="og:image"]', 'content', abs(c ? c.images[0].src : (window.A_ + 'img--hero-a-1600.webp')));
    const ld = $('#ld');
    if (ld) {
      ld.textContent = JSON.stringify(c ? {
        '@context': 'https://schema.org', '@type': 'Product', name: `${c.line.name}, ${c.name}`, image: c.images.map((i) => abs(i.src)),
        brand: { '@type': 'Brand', name: 'FOMOFITS' }, color: c.name, description: c.line.tagline || undefined,
        offers: { '@type': 'Offer', price: (c.almost ? agPrice(c) : c.price).toFixed(2), priceCurrency: 'JOD', availability: c.soldOut ? 'https://schema.org/OutOfStock' : 'https://schema.org/InStock', url: location.href },
      } : {
        '@context': 'https://schema.org', '@type': 'Organization', name: 'FOMOFITS', url: STORE, foundingDate: '2022',
        address: { '@type': 'PostalAddress', addressLocality: 'Amman', addressCountry: 'JO' },
        sameAs: ['https://www.instagram.com/fomo.fits/', 'https://www.tiktok.com/@fomo.fits', 'https://www.facebook.com/people/Fomofits/100083049526819/'],
      });
    }
  }
  let first = true;
  function route() {
    if (first || calm() || !document.startViewTransition) { first = false; render(); return; }
    const t = document.startViewTransition(render);
    t.ready.catch(() => {});
    t.finished.finally(() => $$('img').forEach((im) => { if (im.style.viewTransitionName) im.style.viewTransitionName = ''; }));
  }
  window.addEventListener('hashchange', onNav);
  window.addEventListener('popstate', onNav);
  /* On the live shop, #/ links from a product page move without reloading. A product opens as a real page load (19 Sep):
     only then does Shopify count the product view, for its analytics and the Instagram/Facebook pixel (ViewContent),
     which a move inside the page never triggered. Colour and cut on the product page itself stay instant. */
  document.addEventListener('click', (e) => {
    if (!window.A_ || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest && e.target.closest('a[href]'); if (!a || a.target === '_blank') return;
    const href = a.getAttribute('href');
    if (href.startsWith('/products/')) { if (a.closest('.colours, .seg')) { e.preventDefault(); go(href); } return; }
    if (href.startsWith('#/') && location.pathname !== '/') { e.preventDefault(); go(href); }
  });
  // back from a product page: the grid comes back where she left it, even when the browser reloads it
  // one remembered position per address, so leaving the product page does not overwrite the grid's
  const backMap = () => { try { return JSON.parse(sessionStorage.getItem('fomo2.back') || '{}') || {}; } catch (e) { return {}; } };
  window.addEventListener('pagehide', () => {
    try { const m = backMap(); m[location.href] = window.scrollY; const k = Object.keys(m); if (k.length > 30) delete m[k[0]]; sessionStorage.setItem('fomo2.back', JSON.stringify(m)); } catch (e) { /* no storage */ }
  });
  try { history.scrollRestoration = 'manual'; } catch (e) { /* old browser */ }   // the site restores it itself, below
  const backTo = () => {
    let nav = ''; try { nav = performance.getEntriesByType('navigation')[0].type; } catch (e) { /* old browser */ }
    const y = backMap()[location.href];
    if (!(nav === 'back_forward' && y > 0)) return;
    // the grid may still be growing (photos, fonts): try again until it is tall enough, for up to 3 s
    const t0 = Date.now();
    const go2 = () => { window.scrollTo(0, y); if (Math.abs(window.scrollY - y) > 8 && Date.now() - t0 < 3000) setTimeout(go2, 150); };
    requestAnimationFrame(go2);
  };
  // tapping a card photo: that photo becomes the product page's first photo during the page change
  document.addEventListener('click', (e) => {
    const a = e.target.closest('.pc__media, .mini__img');
    if (!a || !document.startViewTransition || calm() || a.getAttribute('href') === here()) return;
    const im = $('img.a', a) || $('img', a);
    if (im) { im.style.viewTransitionName = 'shot'; shared = im; }
  }, true);
  function bindShots() {
    const r = $('#shots'); const n = $('#shotN');
    if (!r || !n) return;
    r.addEventListener('scroll', () => { n.textContent = String(Math.round(r.scrollLeft / (r.firstElementChild.offsetWidth + 4)) + 1); }, { passive: true });
  }

  /* ---------------- rows ---------------- */
  function updateArrows() {
    $$('.row').forEach((r) => {
      const back = $(`[data-scroll="${r.id}"][data-d="-1"]`); const fwd = $(`[data-scroll="${r.id}"][data-d="1"]`);
      if (!back) return;
      back.disabled = r.scrollLeft <= 4;
      fwd.disabled = r.scrollLeft + r.clientWidth >= r.scrollWidth - 4;
      if (!r.dataset.bound) { r.dataset.bound = '1'; r.addEventListener('scroll', () => updateArrows(), { passive: true }); }
    });
  }
  window.addEventListener('resize', updateArrows);

  /* ---------------- overlays ---------------- */
  let open = null; let lastFocus = null;
  function openOverlay(id) {
    const el = $(`#${id}`);
    if (!el) return;
    if (open && open !== el) closeOverlay(false);
    if (id === 'bag') renderBag();
    if (id === 'saved') renderSaved();
    if (id === 'search') { $('#q').value = ''; renderSearch(); }
    lastFocus = document.activeElement;
    const scrim = $('#scrim');
    el.hidden = false; scrim.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    open = el;
    (id === 'search' ? $('#q') : $('[data-close]', el)).focus({ preventScroll: true });
    requestAnimationFrame(() => { el.classList.add('on'); scrim.classList.add('on'); });
  }
  function closeOverlay(restore = true) {
    if (!open) return;
    const el = open; open = null;
    el.classList.remove('on'); $('#scrim').classList.remove('on');
    document.documentElement.style.overflow = '';
    setTimeout(() => { if (open !== el) el.hidden = true; if (!open) $('#scrim').hidden = true; }, 260);
    if (restore && lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', (e) => {
    const typing = /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName);
    if (!open && !typing && (e.key === '/' || (e.key === 'k' && (e.metaKey || e.ctrlKey)))) { e.preventDefault(); openOverlay('search'); return; }
    if (!open) return;
    if (e.key === 'Escape') { e.preventDefault(); closeOverlay(); return; }
    if (e.key === 'Tab') {
      const f = $$('a[href], button:not([disabled]), input', open).filter((x) => x.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); } else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* ---------------- bag ---------------- */
  const variant = (i) => byKey.get(i.key).variants.find((v) => v.id === i.variantId);
  // how many she can have of one size: the shop's real count when it tracks it, never more than 9
  const maxOf = (v) => (!v || !v.available ? 0 : v.max == null ? 9 : Math.min(9, v.max));
  // the lines that can actually be bought right now (a size that sold out since she added it stays visible but out)
  const bagOK = () => S.bag.filter((i) => maxOf(variant(i)) > 0);
  const tooMany = (v) => `Only ${maxOf(v)} left${v.size ? ` in size ${v.size}` : ''}`;
  function fitBag() {  // keep every line within the real stock
    let changed = false;
    S.bag.forEach((i) => { const m = maxOf(variant(i)); if (m > 0 && i.qty > m) { i.qty = m; i.cut = true; changed = true; } });
    if (changed) store.set('bag', S.bag);
  }
  let bagN = 0;
  function saveBag() {
    store.set('bag', S.bag);
    const n = S.bag.reduce((a, i) => a + i.qty, 0);
    const el = $('#bagCount'); el.textContent = n; el.hidden = n === 0;
    if (n > bagN && bagN !== -1) bump();
    bagN = n;
    headStat();
    if (open && open.id === 'bag') renderBag();
  }
  /* the header reads her bag: how far free delivery is, then which set saving is next.
     Exact numbers, one thin line filling across the header; nothing invented. */
  // if the connection drops, say so plainly instead of failing silently
  function online() {
    const off = !navigator.onLine;
    document.documentElement.classList.toggle('is-offline', off);
    if (off) {
      const box = $('#hstat'); const t = $('#hstatT');
      if (box && t) { box.hidden = false; t.innerHTML = `${EYES}You're offline — showing what's saved on your phone`; }
    } else headStat();
  }
  window.addEventListener('online', online);
  window.addEventListener('offline', online);

  let statWas = 0;
  function headStat() {
    const box = $('#hstat'); if (!box) return;
    if (!navigator.onLine) return;                 // the offline line stays until the connection is back
    if (!S.bag.length) { box.hidden = true; statWas = 0; return; }
    const P = priceBag();
    const bar = $('#hmeterI');
    const tight = window.innerWidth < 760;   // one line only, so it never wraps on a phone
    let txt;
    if (!P.free) txt = tight ? `${money(P.toFree)} to free delivery` : `${money(P.toFree)} away from free delivery`;
    else if (P.next) {
      const sp = setPick(P.next);
      txt = sp
        ? (tight ? `+ ${sp.c.line.name} = −${P.next.off} JOD` : `Delivery is free · add ${an(sp.c.line.name)} ${sp.c.line.name} for ${P.next.name}: −${P.next.off} JOD`)
        : (tight ? `${money(P.next.min - P.next.e)} to −${P.next.off} JOD` : `Delivery is free · ${money(P.next.min - P.next.e)} to ${P.next.name}`);
    } else if (P.got) txt = tight ? `${P.got.name} · −${money(P.got.off)}` : `${P.got.name} on · −${money(P.got.off)} · free delivery`;
    else txt = 'Your delivery is free';
    $('#hstatT').innerHTML = `${EYES}<span>${esc(txt)}</span>`;
    box.hidden = false;
    const p = P.free ? 1 : Math.min(1, P.after / FREE_FROM);
    bar.style.setProperty('--p', p);
    box.classList.toggle('is-on', P.free);
    if (!calm() && p !== statWas) bar.animate([{ transform: `scaleX(${statWas})` }, { transform: `scaleX(${p})` }], { duration: 620, easing: 'cubic-bezier(.2,.8,.2,1)' });
    statWas = p;
  }
  // the top shrinks into a slim glass bar as she scrolls, and the logo swaps to the book's horizontal mark
  (() => {
    let on = false; let raf = 0;
    const set = () => {
      raf = 0;
      const want = window.scrollY > 40;
      if (want !== on) { on = want; document.documentElement.classList.toggle('slim', on); }
    };
    window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(set); }, { passive: true });
    window.addEventListener('resize', () => headStat());
    set();
  })();
  // the order as checkout will price it: best set saving, then free delivery from 50 JOD
  function priceBag() {
    const ok = bagOK();
    const sub = ok.reduce((a, i) => a + variant(i).price * i.qty, 0);
    const inLines = (ls) => ok.filter((i) => ls.includes(byKey.get(i.key).line.id)).reduce((a, i) => a + variant(i).price * i.qty, 0);
    const sets = OFFER_SETS.map((x) => ({ ...x, e: inLines(x.lines) }));
    const best = sets.filter((x) => x.e >= x.min).sort((x, y) => y.off - x.off)[0] || null;
    // Almost gone −10% against the best set: Shopify gives only the bigger one (tested on the shop's cart, 19 Sep)
    const agAll = r2(ok.filter((i) => byKey.get(i.key).almost).reduce((a, i) => a + variant(i).price * i.qty * AG_OFF, 0));
    const useAg = agAll > (best ? best.off : 0);
    const got = useAg ? null : best;
    const ag = useAg ? agAll : 0;
    const agLost = !useAg && agAll > 0 ? agAll : 0;   // a set saves more, so the 10% is not used
    const save = ag || (got ? got.off : 0);
    // never nudge her toward a second pair of leggings: a set whose bottom she already owns in the other cut is not proposed (19 Sep)
    const bottomOutside = (x) => ok.some((i) => { const l = byKey.get(i.key).line; return l.mix === 'bottom' && !x.lines.includes(l.id); });
    const next = sets.find((x) => x.e > 0 && x.e < x.min && x.off > save && !bottomOutside(x)) || null;
    const after = r2(sub - save);
    const free = after >= FREE_FROM;
    const fee = !S.bag.length || free ? 0 : FEES[S.city];
    return { sub, got, ag, agLost, save, next, after, free, fee, toFree: Math.max(0, FREE_FROM - after), total: after + fee };
  }
  const inBag = () => new Set(S.bag.map((i) => i.key));
  // the piece that completes the next set: a missing line first, in a colour already in the bag
  function setPick(next) {
    const have = new Set(S.bag.map((i) => byKey.get(i.key).line.id));
    const names = S.bag.map((i) => byKey.get(i.key).name);
    const missing = next.lines.filter((id) => !have.has(id));
    const pool = missing.length ? missing : next.lines;
    const gap = next.min - next.e;
    const bagged = inBag();
    const hasBottom = S.bag.some((i) => byKey.get(i.key).line.mix === 'bottom');
    const cands = live.filter((c) => pool.includes(c.line.id) && !bagged.has(c.key) && !(hasBottom && c.line.mix === 'bottom'));
    const score = (c) => (names.some((nm) => sameName(nm, c.name)) ? 4 : 0) + (c.price >= gap ? 2 : 0) + (prefFor(c) ? 1 : 0);
    cands.sort((x, y) => score(y) - score(x) || (pool.indexOf(x.line.id) - pool.indexOf(y.line.id)) || x.price - y.price);
    return cands[0] ? { c: cands[0], gap } : null;
  }
  // the smallest piece that goes with the bag and reaches free delivery
  function freePick(P) {
    if (P.free || !S.bag.length) return null;
    const firstPiece = byKey.get(S.bag[0].key);
    const pool = goesWith(firstPiece, 12, inBag()).filter((c) => c.price >= P.toFree).sort((x, y) => x.price - y.price);
    return pool[0] || null;
  }
  const an = (s) => (/^[aeiou]/i.test(s) ? 'an' : 'a');
  function offerBlock(P, withPick) {
    let pick = '';
    let set = '';
    // each sentence is one text node so the Arabic patterns in i18n.js can translate it whole (19 Sep)
    if (P.got) set += `<p class="setnote">${esc(`${P.got.name} is on: ${money(P.got.off)} off.`)}</p>`;
    if (P.next) {
      const sp = setPick(P.next);
      const more = P.got ? ` instead of ${P.got.off}` : '';
      set += sp && sp.c.price >= sp.gap
        ? `<p class="setnote">${esc(`Add ${an(sp.c.line.name)} ${sp.c.line.name} to get ${P.next.name}: ${P.next.off} JOD off${more}.`)}</p>`
        : `<p class="setnote">${esc(`Add ${money(P.next.min - P.next.e)} more of set pieces to get ${P.next.name}: ${P.next.off} JOD off${more}.`)}</p>`;
      if (withPick && sp) pick = mini(sp.c, 'Completes the set');
    }
    if (withPick && !pick) { const fp = freePick(P); if (fp) pick = mini(fp, 'Free delivery with this'); }
    const p = Math.min(1, P.after / FREE_FROM);
    const meter = `<div class="meter"><p>${P.free ? '<b>Free delivery</b> is on for this order.' : `You're <b class="num">${money(P.toFree)}</b> away from free delivery.`}</p><div class="meter__bar"><i style="--p:${p}"></i></div></div>`;
    const rest = `${set}${pick ? `<div class="offers__pick">${pick}</div>` : ''}`;
    if (withPick) return { meter: `<div class="offers">${meter}</div>`, rest: rest ? `<div class="offers offers--end">${rest}</div>` : '' };
    return `<div class="offers">${meter}${rest}</div>`;
  }
  let meterWas = 0;
  function growMeter(root) {
    const i = $('.meter__bar i', root); if (!i) return;
    const p = Number(i.style.getPropertyValue('--p'));
    if (!calm() && p !== meterWas) i.animate([{ transform: `scaleX(${meterWas})` }, { transform: `scaleX(${p})` }], { duration: 650, easing: 'cubic-bezier(.2,.8,.2,1)' });
    meterWas = p;
  }
  function renderBag() {
    const body = $('#bagBody'); const foot = $('#bagFoot');
    const n = S.bag.reduce((a, i) => a + i.qty, 0);
    $('#bagTitle').textContent = n ? `Your bag · ${n} ${n === 1 ? 'piece' : 'pieces'}` : 'Your bag';
    if (!S.bag.length) {
      body.innerHTML = `<div class="empty"><span class="empty__face" aria-hidden="true">${B.oEyes}</span><p class="empty__t">FOMO alert.</p><p>Your bag is empty. The new collection just landed.</p><a class="btn" href="#/shop/new">Shop the new collection</a></div>`;
      foot.hidden = true; meterWas = 0; return;
    }
    foot.hidden = false;
    fitBag();
    const P = priceBag();
    const lines = S.bag.map((i, k) => {
      const c = byKey.get(i.key); const v = variant(i); const m = maxOf(v);
      if (!m) {
        return `<div class="line line--out">
        <a class="line__img" href="${pHref(c.key)}">${img(c.images[0].src, '', c.images[0].w, c.images[0].h)}</a>
        <div class="line__info">
          <div class="line__top"><span>${esc(c.line.name)}</span><span class="num">Sold out</span></div>
          <span class="line__meta">${esc(c.name)}${v && v.size ? ` · ${v.size}` : ''}</span>
          <p class="line__note">This size sold out since you added it. It won't be in your order.</p>
          <div class="line__ctl"><span class="line__acts"><a class="remove" href="${pHref(c.key)}">Other sizes</a><button class="remove" type="button" data-remove="${k}">Remove</button></span></div>
        </div>
      </div>`;
      }
      const note = i.cut ? `<p class="line__note">${esc(tooMany(v))}, so we changed this to ${m}.</p>` : '';
      return `<div class="line">
        <a class="line__img" href="${pHref(c.key)}" aria-label="${esc(title(c))}">${img(c.images[0].src, '', c.images[0].w, c.images[0].h)}</a>
        <div class="line__info">
          <div class="line__top"><span>${esc(c.line.name)}</span><span class="num">${money(v.price * i.qty)}</span></div>
          <span class="line__meta">${esc(c.name)}${v.size ? ` · ${v.size}` : ''}</span>
          <div class="line__ctl">
            <div class="qty" role="group" aria-label="Quantity">
              <button type="button" data-qty="${k}" data-d="-1" aria-label="One less">−</button>
              <output class="num">${i.qty}</output>
              <button type="button" data-qty="${k}" data-d="1" aria-label="One more" ${i.qty >= m ? 'aria-disabled="true"' : ''}>+</button>
            </div>
            <span class="line__acts"><button class="remove" type="button" data-later="${k}">Save for later</button><button class="remove" type="button" data-remove="${k}">Remove</button></span>
          </div>
          ${note}
        </div>
      </div>`;
    }).join('');
    const ob = offerBlock(P, true);
    /* 19 Sep: the delivery choice and the totals scroll with the pieces. Pinned under them they took 413 of the 664 px
       on an iPhone 13 (the pieces got 191 px, 32 px on an iPhone SE in Arabic); now only Checkout stays pinned. */
    body.innerHTML = `${ob.meter}${lines}${ob.rest}<div class="bagsum">
      <fieldset class="city"><legend>Delivery</legend>
        <label><input type="radio" name="city" value="amman" ${S.city === 'amman' ? 'checked' : ''}> Amman, same day (before 4 pm) <span class="num">${P.free ? '<s>JOD 3</s> Free' : 'JOD 3'}</span></label>
        <label><input type="radio" name="city" value="other" ${S.city === 'other' ? 'checked' : ''}> Other cities, 1–2 working days <span class="num">${P.free ? '<s>JOD 5</s> Free' : 'JOD 5'}</span></label>
      </fieldset>
      <div class="totals">
        <div><span>Subtotal</span><span class="num">${money(P.sub)}</span></div>
        ${P.got ? `<div class="save-row"><span>${P.got.name}</span><span class="num">−${money(P.save)}</span></div>` : ''}
        ${P.ag ? `<div class="save-row"><span>Almost gone −10%</span><span class="num">−${money(P.ag)}</span></div>` : ''}
        <div><span>Delivery</span><span class="num" id="feeVal">${P.free ? `<s>${money(FEES[S.city])}</s> Free` : money(P.fee)}</span></div>
        ${P.save || P.free ? `<div class="save-row save-row--total"><span>You save</span><span class="num">${money(P.save + (P.free ? FEES[S.city] : 0))}</span></div>` : ''}
        <div class="grand"><span>Total</span><span class="num">${money(P.total)}</span></div>
      </div>
      ${P.agLost ? `<p class="fine">${esc(P.got.name)} saves you more than Almost gone −10%, so checkout uses the set. One saving per order.</p>` : ''}
      <p class="fine">Pay by cash or CliQ when your order arrives, not before. Set savings and free delivery are applied for you at checkout; no code needed.</p>
      <p class="fine">Checkout asks for your email. Use one you can open: your orders live under it, and if you ever need an exchange it takes one tap.</p></div>`;
    growMeter(body);
    // what she risks (nothing) and what she saves, right where she decides (audit, 19 Sep)
    const saved = P.save + (P.free ? FEES[S.city] : 0);
    foot.innerHTML = `
      <p class="assure assure--foot">${saved ? `${esc(`You save ${money(saved)}`)} · ` : ''}Cash or CliQ on delivery · Exchange within 3 days</p>
      <a class="btn btn--wide btn--split" id="checkout" href="${STORE}/cart/${bagOK().map((i) => `${i.variantId}:${i.qty}`).join(',')}" ${ON_SHOPIFY ? '' : 'target="_blank" rel="noopener"'}><span>Checkout</span><span class="num">${money(P.total)}</span></a>`;
  }

  /* ---------------- added: what she just put in, what goes with it, how close the next saving is ---------------- */
  function openAdded(added) {
    const P = priceBag();
    const firstPiece = byKey.get(added[0].key);
    const sug = goesWith(firstPiece, 3, inBag());
    $('#addedBody').innerHTML = `
      <div class="added__list">${added.map(({ key, size }) => {
        const c = byKey.get(key);
        return `<div class="added__item"><div class="line__img">${img(c.images[0].src, '', c.images[0].w, c.images[0].h)}</div>
          <div class="line__info"><div class="line__top"><span>${esc(c.line.name)}</span><span class="num">${priceTag(c)}</span></div><span class="line__meta">${esc(c.name)}${size ? ` · ${size}` : ''}</span></div></div>`;
      }).join('')}</div>
      ${P.ag ? `<p class="setnote">${esc(`Almost gone −10%: −${money(P.ag)} at checkout.`)}</p>` : ''}
      ${offerBlock(P, false)}
      ${sug.length ? `<h3 class="added__h">Goes with it</h3><div class="minis">${sug.map((c) => mini(c)).join('')}</div>` : ''}`;
    const n = S.bag.reduce((a, i) => a + i.qty, 0);
    // the number she sees after committing equals the one she accepted: pieces first, delivery named on its own (audit, 19 Sep)
    $('#addedBag').innerHTML = `<span>View bag · ${n} ${n === 1 ? 'piece' : 'pieces'}</span><span class="num">${money(P.after)}${P.fee ? `<small>${esc(`+ ${money(P.fee)} delivery`)}</small>` : ''}</span>`;
    openOverlay('added');
    growMeter($('#addedBody'));
  }

  function add(key) {
    const c = byKey.get(key);
    const v = c.sizes.length ? c.sizes.find((x) => x.size === S.size) : c.variants[0];
    if (!v) {
      const hint = $('#sizeHint'); if (hint) hint.textContent = 'Choose your size first.';
      const firstSize = $('.size:not([disabled])'); if (firstSize) { firstSize.scrollIntoView({ block: 'center', behavior: 'smooth' }); firstSize.focus({ preventScroll: true }); }
      return;
    }
    if (!v.available) return;
    const n = putInBag(key, v, S.pick || 1);
    if (!n) return;
    S.pick = 1; const pn = $('#pickN'); if (pn) pn.textContent = '1';
    saveBag();
    openAdded([{ key, size: v.size }]);
  }
  // the size she has picked on the product page (or the only variant), for the quantity stepper
  function pickedVariant() {
    const k = (here().match(/^#\/p\/(.+)$/) || [])[1]; const c = k && byKey.get(k); if (!c) return null;
    return c.sizes.length ? c.sizes.find((x) => x.size === S.size) || null : c.variants[0];
  }
  // one tap from a "Complete the look" row: her remembered size, straight in
  function addDirect(key) {
    const c = byKey.get(key);
    const v = c.avail.find((x) => x.size === S.pref);
    if (!v) { openSheet([key]); return; }
    putInBag(key, v);
    saveBag();
    openAdded([{ key, size: v.size }]);
  }
  function putInBag(key, v, n = 1) {
    const hit = S.bag.find((i) => i.key === key && i.variantId === v.id);
    const have = hit ? hit.qty : 0; const room = maxOf(v) - have; const add = Math.min(n, room);
    if (add <= 0) { toast(`${tooMany(v)} — ${have ? 'already in your bag' : 'sold out'}`); return 0; }
    if (hit) { hit.qty += add; delete hit.cut; } else S.bag.push({ key, variantId: v.id, qty: add });
    cartAdd(v.id, add);
    if (add < n) toast(`${tooMany(v)}, so we added ${add}`);
    return add;
  }
  /* On the live shop the bag is mirrored into Shopify's own cart (19 Sep): adding goes through /cart/add.js, which is
     what fires Shopify's "added to cart" event for its analytics and the Meta/Instagram pixel. Checkout then makes the
     cart match the bag exactly. Off Shopify (the preview link) none of this runs and checkout uses a cart link. */
  const ON_SHOPIFY = !!window.A_;
  if (ON_SHOPIFY) document.documentElement.classList.add('shop');
  /* Accounts (20 Sep, his ask): Shopify's new customer accounts, passwordless (an email code; phone login is not offered in Jordan), and the
     session stays on her phone once she has signed in. The links point at /account; when the layout says who she is,
     they greet her by name. */
  if (ON_SHOPIFY) {
    const name = window.FOMO_CUSTOMER;
    document.querySelectorAll('[data-account]').forEach((el) => {
      if (!name) return;
      if (el.classList.contains('icon')) el.setAttribute('aria-label', `Your account, ${name}`);
      else el.textContent = `Hi ${name} · Your account`;
    });
  }
  const cartPost = (path, body) => fetch(`/cart/${path}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then((r) => r.json());
  function cartAdd(id, quantity = 1) { if (ON_SHOPIFY) cartPost('add', { items: [{ id, quantity }] }).catch(() => { /* checkout syncs anyway */ }); }
  async function cartSync() {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const want = new Map(); bagOK().forEach((i) => want.set(i.variantId, (want.get(i.variantId) || 0) + i.qty));
    const updates = {};
    cart.items.forEach((it) => { if (!want.has(it.variant_id)) updates[it.variant_id] = 0; });
    want.forEach((q, id) => { const it = cart.items.find((x) => x.variant_id === id); if (!it || it.quantity !== q) updates[id] = q; });
    if (Object.keys(updates).length) await cartPost('update', { updates });
  }
  const rememberSize = (size) => { S.pref = size; store.set('size', size); };
  // Buy now: this one piece, straight to the shop's checkout
  function buyNow(key) {
    const c = byKey.get(key);
    const v = c.sizes.length ? c.sizes.find((x) => x.size === S.size) : c.variants[0];
    if (!v) {
      const hint = $('#sizeHint'); if (hint) hint.textContent = 'Choose your size first.';
      const first = $('.size:not([disabled])'); if (first) { first.scrollIntoView({ block: 'center', behavior: 'smooth' }); first.focus({ preventScroll: true }); }
      return;
    }
    if (!v.available) return;
    const q = Math.max(1, Math.min(maxOf(v), S.pick || 1));
    if (ON_SHOPIFY) { store.set('checkout', null); location.href = `/cart/${v.id}:${q}`; return; }   // not a bag order: keep the bag
    window.open(`${STORE}/cart/${v.id}:${q}`, '_blank', 'noopener');
  }
  // back in stock: a ready message to send on Instagram (no server here to keep a list)
  async function notifyMe(what) {
    const msg = `Hi FOMOFITS, please tell me when the ${what} is back in stock.`;
    try { await navigator.clipboard.writeText(msg); } catch (e) { /* clipboard refused */ }
    toast('Message copied — paste it in your DM', 'Open Instagram', () => window.open('https://ig.me/m/fomo.fits', '_blank', 'noopener'));
  }
  // share: the phone's own share sheet, or copy the link
  async function share(key) {
    const c = byKey.get(key);
    const url = new URL(pHref(key), `${location.origin}${location.pathname}`).href;
    const data = { title: `${c.line.name}, ${c.name} · FOMOFITS`, text: `${title(c)} — ${money(c.almost ? agPrice(c) : c.price)}`, url };
    try {
      if (navigator.share) { await navigator.share(data); return; }
      await navigator.clipboard.writeText(url);
      toast('Link copied');
    } catch (e) { /* she cancelled, or the browser refused */ }
  }
  // a photo full screen: tap to close, arrows or swipe to move
  let zoomAt = 0; let zoomKeys = [];
  function openZoom(i) {
    const c = byKey.get((here().match(/^#\/p\/(.+)$/) || [])[1] || '');
    if (!c) return;
    zoomKeys = c.images; zoomAt = i;
    drawZoom();
    openOverlay('zoom');
  }
  function drawZoom() {
    const im = zoomKeys[zoomAt];
    $('#zoomImg').src = im.src;
    $('#zoomN').textContent = `${zoomAt + 1} / ${zoomKeys.length}`;
  }
  function stepZoom(d) { zoomAt = (zoomAt + d + zoomKeys.length) % zoomKeys.length; drawZoom(); }

  /* ---------------- quick add sheet: pick sizes for one piece or a whole set ---------------- */
  const SH = { keys: [], sizes: {}, name: '' };
  function openSheet(keys, name = '') {
    const items = keys.map((k) => byKey.get(k)).filter((c) => c && !c.soldOut);
    if (!items.length) return;
    // pieces without sizes go straight in
    if (items.length === 1 && !items[0].sizes.length) { S.size = null; add(items[0].key); return; }
    SH.keys = items.map((c) => c.key); SH.name = name; SH.sizes = {};
    items.forEach((c) => { if (S.pref && c.avail.some((v) => v.size === S.pref)) SH.sizes[c.key] = S.pref; });
    $('#sheetTitle').textContent = name || 'Choose your size';
    $('#sheetBody').innerHTML = items.map((c) => `<div class="sheet__item">
      <div class="sheet__img">${img(c.images[0].src, '', c.images[0].w, c.images[0].h)}</div>
      <div class="sheet__info">
        <b>${esc(c.line.name)}</b><span>${esc(c.name)} · <span class="num">${money(c.price)}</span></span>
        ${c.sizes.length ? `<div class="sizes" role="group" aria-label="Size for ${esc(c.line.name)}">${c.sizes.map((v) => `<button type="button" class="size" data-ssize="${v.size}" data-skey="${esc(c.key)}" aria-pressed="${SH.sizes[c.key] === v.size}" ${v.available ? '' : 'disabled'} aria-label="${v.size}${v.available ? '' : ', sold out'}">${v.size}</button>`).join('')}</div>` : '<span class="hint">One size</span>'}
      </div>
    </div>`).join('');
    const total = items.reduce((a, c) => a + c.price, 0);
    // a set: the card said 60 with 67 struck, so the sheet says the same and names the saving (audit, 19 Sep)
    const setOn = items.length > 1 ? OFFER_SETS.filter((x) => items.every((c) => x.lines.includes(c.line.id)) && total >= x.min).sort((x, y) => y.off - x.off)[0] : null;
    const picked = S.pref && items.every((c) => !c.sizes.length || SH.sizes[c.key]) ? `We picked ${S.pref}, the size you chose last time.` : '';
    $('#sheetHint').textContent = setOn ? `${setOn.off} JOD comes off at checkout.${picked ? ` ${picked}` : ''}` : picked;
    $('#sheetAdd').innerHTML = `<span>${items.length > 1 ? `Add ${items.length} pieces` : 'Add to bag'}</span><span class="num">${setOn ? `${money(total - setOn.off)} <s>${money(total)}</s>` : money(total)}</span>`;
    openOverlay('sheet');
  }
  function sheetAdd() {
    const items = SH.keys.map((k) => byKey.get(k));
    const missing = items.find((c) => c.sizes.length && !SH.sizes[c.key]);
    if (missing) { $('#sheetHint').textContent = `Choose a size for the ${missing.line.name}.`; const b = $(`[data-skey="${CSS.escape(missing.key)}"]:not([disabled])`); if (b) b.focus(); return; }
    items.forEach((c) => putInBag(c.key, c.sizes.length ? c.sizes.find((v) => v.size === SH.sizes[c.key]) : c.variants[0]));
    saveBag();
    openAdded(items.map((c) => ({ key: c.key, size: SH.sizes[c.key] || '' })));
  }
  $('#sheetAdd').addEventListener('click', sheetAdd);

  /* ---------------- saved ---------------- */
  function saveSaved() {
    store.set('saved', S.saved);
    const n = S.saved.length; const el = $('#savedCount'); el.textContent = n; el.hidden = n === 0;
    if (open && open.id === 'saved') renderSaved();
  }
  function toggleSave(key) {
    const on = !S.saved.includes(key);
    S.saved = on ? [key, ...S.saved] : S.saved.filter((k) => k !== key);
    saveSaved();
    const c = byKey.get(key);
    $$(`[data-save="${CSS.escape(key)}"]`).forEach((b) => {
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', `${on ? 'Remove from saved' : 'Save'}${b.classList.contains('pc__save') ? `: ${title(c)}` : ''}`);
    });
    toast(on ? 'Saved' : 'Removed from saved', on ? 'View saved' : null, on ? () => openOverlay('saved') : null);
  }
  function renderSaved() {
    const body = $('#savedBody');
    if (!S.saved.length) { body.innerHTML = `<div class="empty"><span class="empty__face" aria-hidden="true">${B.oEyes}</span><p>Nothing saved yet. Tap the heart on any piece to keep it here.</p></div>`; return; }
    body.innerHTML = S.saved.map((k) => {
      const c = byKey.get(k);
      return `<div class="line">
        <a class="line__img" href="${pHref(k)}">${img(c.images[0].src, '', c.images[0].w, c.images[0].h)}</a>
        <div class="line__info">
          <div class="line__top"><span>${esc(c.line.name)}</span><span class="num">${money(c.price)}</span></div>
          <span class="line__meta">${esc(c.name)}${c.soldOut ? ' · sold out' : c.lastSize ? ` · only ${c.avail[0].size} left` : ''}</span>
          <div class="line__ctl"><a class="textlink" href="${pHref(k)}">Choose size</a><button class="remove" type="button" data-save="${esc(k)}">Remove</button></div>
        </div>
      </div>`;
    }).join('');
  }

  /* ---------------- search ---------------- */
  // words shoppers type that aren't in the product names
  const SYN = {
    pants: ['flare', 'leggings'], trousers: ['flare'], flares: ['flare'], legging: ['leggings'], tights: ['leggings'],
    top: ['tank', 'wrap', 'curve', 'tee'], shirt: ['tee', 'tank'], tshirt: ['tee'], 't-shirt': ['tee'], crop: ['tank'],
    hoodie: ['hoodie'], zip: ['jacket'], set: ['jacket', 'leggings'], gym: ['leggings', 'tank'], sport: ['leggings', 'tank'],
    grey: ['gray'], gray: ['grey'], navy: ['navy', 'blue'], beige: ['beige', 'cream', 'sand'],
  };
  const AR_Q = {
    'لجنز': 'leggings', 'ليقنز': 'leggings', 'ليجنز': 'leggings', 'لقنز': 'leggings', 'ليغنز': 'leggings', 'بنطلون': 'pants', 'بناطيل': 'pants', 'فلير': 'flare', 'واسع': 'flare',
    'جاكيت': 'jacket', 'جاكيتات': 'jacket', 'جاكيتة': 'jacket', 'تيشيرت': 'top', 'تيشيرتات': 'top', 'تي': 'tee', 'بلوزة': 'top', 'بلايز': 'top', 'توب': 'top', 'هودي': 'hoodie',
    'طقم': 'set', 'أطقم': 'set', 'اطقم': 'set', 'أسود': 'black', 'اسود': 'black', 'أبيض': 'white', 'ابيض': 'white', 'رمادي': 'grey', 'زهري': 'pink', 'وردي': 'pink',
    'أخضر': 'green', 'اخضر': 'green', 'زيتي': 'olive', 'كحلي': 'navy', 'أزرق': 'blue', 'ازرق': 'blue', 'بني': 'brown', 'بيج': 'beige', 'خمري': 'burgundy', 'عنابي': 'burgundy',
    'أحمر': 'red', 'احمر': 'red', 'بنفسجي': 'purple', 'مقاس': 'size',
  };
  const recent = {
    list: () => store.get('recent', []),
    add(q) { const l = [q, ...this.list().filter((x) => x !== q)].slice(0, 6); store.set('recent', l); },
    clear() { store.set('recent', []); renderSearch(); },
  };
  function renderSearch() {
    const q = $('#q').value.trim().toLowerCase();
    const body = $('#qBody');
    if (!q) {
      const seen = S.seen.map((k) => byKey.get(k)).filter((c) => c && !c.soldOut).slice(0, 6);
      const rec = recent.list();
      body.innerHTML = `${rec.length ? `<p class="hint">Recent <button class="linkish" type="button" data-rclear>clear</button></p><div class="suggest">${rec.map((r) => `<button type="button" data-redo="${esc(r)}">${esc(r)}</button>`).join('')}</div>` : ''}
        <p class="hint">Popular</p><div class="suggest">${['leggings', 'tops', 'jackets', 'flares'].map((g) => `<a href="#/shop/${g}">${GROUPS[g].title}</a>`).join('')}<a href="#/shop/new">New in</a></div>
        ${seen.length ? `<p class="hint">You looked at</p><div class="grid">${seen.map(card).join('')}</div>`
    : `<div class="grid">${live.filter((c) => c.new).slice(0, 6).map(card).join('')}</div>`}`;
      return;
    }
    // Arabic words search the same pieces (19 Sep audit: Arabic search found nothing), and a size ("m", "size m", "مقاس M") filters by stock
    const parts = q.split(/\s+/).map((t) => AR_Q[t] || t).join(' ').split(/\s+/).filter((t) => t && t !== 'size');
    const size = parts.find((t) => /^(xs|s|m|l|xl|xxl)$/.test(t));
    const terms = parts.filter((t) => t !== size);
    const words = (s) => s.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
    const hits = live.filter((c) => {
      if (size && !c.avail.some((v) => v.size.toLowerCase() === size)) return false;
      const ws = words(`${c.line.name} ${c.name} ${c.family || ''} ${c.line.group} ${Math.round(c.price)}`);
      return terms.every((raw) => [raw, ...(SYN[raw] || [])].some((t) => ws.some((w) => w.startsWith(t))));
    });
    body.innerHTML = hits.length
      ? `<p class="hint">${hits.length} ${hits.length === 1 ? 'result' : 'results'}</p><div class="grid" style="margin-top:14px">${hits.slice(0, 18).map(card).join('')}</div>`
      : `<p class="hint">Nothing found for “${esc(q)}”. Try leggings, tank, black or olive.</p>`;
  }
  $('#q').addEventListener('input', renderSearch);
  $('#q').addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      const v = $('#q').value.trim(); if (v) recent.add(v.toLowerCase());
      const first = $('#qBody .pc__media'); if (first) { const h = first.getAttribute('href'); if (window.A_ && h.startsWith('/products/')) location.href = h; else go(h); }
    }
  });

  /* ---------------- toast ---------------- */
  let tt = 0;
  function toast(msg, label, fn) {
    const t = $('#toast');
    t.innerHTML = `<span>${esc(msg)}</span>${label ? `<button type="button">${esc(label)}</button>` : ''}`;
    if (label) $('button', t).onclick = () => { t.classList.remove('on'); fn(); };
    t.classList.add('on');
    clearTimeout(tt); tt = setTimeout(() => t.classList.remove('on'), 3200);
  }

  /* ---------------- clicks ---------------- */
  document.addEventListener('click', (e) => {
    if (e.target.id === 'scrim') { closeOverlay(); return; }
    const co = e.target.closest && e.target.closest('#checkout');
    if (co && ON_SHOPIFY) {
      e.preventDefault(); co.setAttribute('aria-busy', 'true'); const lbl = co.querySelector('span'); if (lbl) lbl.textContent = 'Opening checkout…';
      const fallback = co.getAttribute('href');
      const mark = () => store.set('checkout', { t: Date.now() });   // see "back from Shopify" at the end
      cartSync().then(() => { mark(); location.href = `/checkout${window.FOMO_LANG === 'ar' && window.FOMO_AR_CHECKOUT ? '?locale=ar' : ''}`; }, () => { mark(); location.href = fallback; });
      return;
    }
    const t = e.target.closest('button, a');
    if (!t) return;
    const d = t.dataset;
    if ('close' in d) { closeOverlay(); return; }
    if (d.open) { openOverlay(d.open); return; }
    if (d.save) { e.preventDefault(); toggleSave(d.save); return; }
    if (d.zstep) { stepZoom(Number(d.zstep)); return; }
    if (d.scroll) { const r = $(`#${d.scroll}`); r.scrollBy({ left: Number(d.d) * r.clientWidth * 0.9, behavior: 'smooth' }); return; }
    if (d.size) {
      S.size = d.size; rememberSize(d.size);
      $$('.size').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.size === S.size)));
      const v = pickedVariant(); const m = maxOf(v);
      if (S.pick > m) { S.pick = Math.max(1, m); const pn = $('#pickN'); if (pn) pn.textContent = String(S.pick); }
      const hint = $('#sizeHint'); if (hint) hint.textContent = v && v.max != null && v.max <= 3 ? `Size ${S.size} · only ${v.max} left` : `Size ${S.size}`;
      return;
    }
    if (d.pq) {  // quantity on the product page: never more than the shop really has of that size
      const v = pickedVariant(); const m = v ? maxOf(v) : 9; const want = (S.pick || 1) + Number(d.pq);
      if (Number(d.pq) > 0 && want > m) { toast(v ? tooMany(v) : 'Choose your size first'); return; }
      S.pick = Math.max(1, Math.min(m || 1, want)); const pn = $('#pickN'); if (pn) pn.textContent = String(S.pick);
      return;
    }
    if (d.add) { add(d.add); return; }
    if (d.share) { share(d.share); return; }
    if (d.buynow) { buyNow(d.buynow); return; }
    if (d.notify) { notifyMe(d.notify); return; }
    if ('exback' in d) { EX.order = null; EX.picks = {}; EX.step = 1; route(); return; }
    if (d.exorder) { exFromOrder(d.exorder); return; }
    if ('exnext' in d) { EX.step = 3; route(); return; }
    if (d.exstep) { EX.step = Number(d.exstep); route(); return; }
    if (d.exreason) { EX.picks[d.exreason].reason = d.val; exRender(); return; }
    if (d.exsize) { EX.picks[d.exsize].size = d.val; EX.picks[d.exsize].colour = EX.picks[d.exsize].colour || null; exRender(); return; }
    if (d.excolour) { EX.picks[d.excolour].colour = d.val; EX.picks[d.excolour].other = null; exRender(); return; }
    if (d.zoom !== undefined && d.zoom !== '') { openZoom(Number(d.zoom)); return; }
    if ('fmine' in d) { F.mine = !F.mine; refilter(); return; }
    if (d.redo) { $('#q').value = d.redo; renderSearch(); $('#q').focus(); return; }
    if ('rclear' in d) { recent.clear(); return; }
    if (d.quick) { if (d.direct) addDirect(d.quick); else openSheet([d.quick]); return; }
    if (d.fsize) { F.size = F.size === d.fsize ? null : d.fsize; if (F.size) rememberSize(F.size); refilter(); return; }
    if (d.fam) { F.fam = F.fam === d.fam ? null : d.fam; refilter(); return; }
    if ('fclear' in d) { F.size = null; F.fam = null; F.mine = false; refilter(); return; }
    if (d.set) { openSheet(d.set.split(','), d.setname || ''); return; }
    if ('replay' in d) { e.preventDefault(); intro(true); return; }
    if (d.pick) { ST[d.pick === 'tops' ? 'top' : 'bottom'] = Number(d.i); restyle(); return; }
    if (d.jump) { const el = document.getElementById(d.jump); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    if (d.ssize) {
      SH.sizes[d.skey] = d.ssize; rememberSize(d.ssize);
      $$(`[data-skey="${CSS.escape(d.skey)}"]`).forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.ssize === d.ssize)));
      $('#sheetHint').textContent = '';
      return;
    }
    if (d.swatch) {
      const c = byKey.get(d.swatch); const cardEl = t.closest('.lc');
      if (!c || !cardEl) return;
      const [a, b] = c.images;
      cardEl.querySelector('img.a').src = a.src;
      const ib = cardEl.querySelector('img.b'); if (ib && b) ib.src = b.src;
      cardEl.querySelectorAll('a').forEach((x) => { x.href = `${pHref(c.key)}`; });
      cardEl.querySelector('.pc__media').setAttribute('aria-label', title(c));
      cardEl.querySelector('.lc__colour').textContent = c.name;
      cardEl.querySelector('.pc__price').innerHTML = priceTag(c);
      const q = cardEl.querySelector('.pc__add'); q.dataset.quick = c.key; q.setAttribute('aria-label', `Quick add: ${title(c)}`);
      cardEl.querySelectorAll('[data-swatch]').forEach((x) => x.setAttribute('aria-pressed', String(x === t)));
      return;
    }
    if (d.qty) { const i = S.bag[Number(d.qty)]; const v = variant(i); const m = maxOf(v); delete i.cut;
      if (Number(d.d) > 0 && i.qty >= m) { toast(tooMany(v)); return; }
      i.qty = Math.max(1, Math.min(m, i.qty + Number(d.d))); saveBag(); return; }
    if (d.later) {
      const n = Number(d.later); const it = S.bag[n]; const key = it.key;
      S.bag.splice(n, 1); saveBag();
      if (!S.saved.includes(key)) { S.saved = [key, ...S.saved]; saveSaved(); }
      toast('Saved for later', 'View saved', () => openOverlay('saved'));
      return;
    }
    if (d.remove) {
      const n = Number(d.remove); const [gone] = S.bag.splice(n, 1); saveBag();
      toast('Removed from bag', 'Undo', () => { S.bag.splice(n, 0, gone); saveBag(); });
      return;
    }
    // a link to the page you're already on still closes the overlay
    const href = t.getAttribute('href') || '';
    if ((href.startsWith('#/') || href.startsWith('/products/')) && (href === here() || href === location.pathname + location.search)) closeOverlay(false);
  });
  document.addEventListener('change', (e) => {
    if (e.target.dataset && e.target.dataset.exother !== undefined) {
      const pk = EX.picks[e.target.dataset.exother]; pk.other = e.target.value || null; pk.colour = null; pk.size = '';
      exRender(); const sel = document.getElementById(e.target.id); if (sel) sel.focus({ preventScroll: true }); return;
    }
    if (e.target.dataset && e.target.dataset.expick !== undefined) {
      const i = e.target.dataset.expick;
      if (e.target.checked) EX.picks[i] = { reason: '', size: '', colour: null }; else delete EX.picks[i];
      exRender();
      return;
    }
    if (e.target.id === 'exAgree') { const b = $('[data-exsend]'); if (b) b.disabled = !e.target.checked; return; }
    if (e.target.id === 'sort') { F.sort = e.target.value; refilter(); return; }
    if (e.target.name === 'city') { S.city = e.target.value; store.set('city', S.city); renderBag(); $(`input[name="city"][value="${S.city}"]`)?.focus(); }
  });

  document.addEventListener('submit', (e) => {
    if (e.target.id !== 'exMail') return;
    if (!ON_SHOPIFY) { e.preventDefault(); EX.sent = true; route(); return; }
    try { sessionStorage.setItem('fomo2.exsent', String(EX.order ? EX.order.no : '')); } catch (err) { /* no storage */ }
  });
  // back from Shopify's contact endpoint: the request went, show the sent state
  if (/[?&](contact_posted=true|sent=)/.test(location.search)) {
    const m = location.search.match(/[?&]sent=(\d+)/); EX.sent = true; EX.sentNo = m ? m[1] : '';
    try { if (!EX.sentNo) EX.sentNo = sessionStorage.getItem('fomo2.exsent') || ''; sessionStorage.removeItem('fomo2.exsent'); } catch (err) { /* no storage */ }
    history.replaceState(null, '', '/#/exchange');
  }

  /* ---------------- boot ---------------- */
  $$('[data-slot]').forEach((el) => {
    const k = el.dataset.slot;
    if (k === 'logoH') el.innerHTML = B.logoH;
    if (k === 'artsy') el.innerHTML = B.artsy;
    if (k === 'eyes') el.innerHTML = B.eyes;
    if (k === 'logoStack' || k === 'logoH') el.innerHTML = B[k];
    if (k === 'logoStack') el.innerHTML = B.logoStack;
    if (k === 'eyesStacked') el.innerHTML = B.eyesStacked;
    if (k === 'xoxo') el.innerHTML = B.xoxo;
    if (k === 'credit') el.innerHTML = B.logoH;
  });
  // repeat visits load from the phone; harmless where service workers are not allowed
  if ('serviceWorker' in navigator && !window.A_) {   // no service worker on Shopify
    window.addEventListener('load', () => { navigator.serviceWorker.register('sw.js').catch(() => { /* not allowed here */ }); });
  }
  bagN = -1;
  saveBag();
  online();
  saveSaved();
  intro();
  route();
  backTo();
  if (ON_SHOPIFY) {
    /* Back from Shopify (19 Sep). An order placed from the bag empties Shopify's cart, but the bag lives on the phone
       and kept showing the pieces she had just bought. So: if she went to checkout from the bag and Shopify's cart is
       now empty, the order went through; empty the bag too. A cart she left at checkout still has its pieces. Shopify
       keeps a cart 14 days, so after 10 days an empty cart proves nothing and the bag stays. */
    const co = store.get('checkout', null);
    if (co && S.bag.length) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((cart) => {
        if (cart.item_count > 0) return;
        store.set('checkout', null);
        if (!(Date.now() - co.t < 10 * 864e5)) return;
        S.bag = []; saveBag(); if (open && open.id === 'bag') renderBag();
        toast('Thank you for your order. Your bag is empty again.');
      }).catch(() => { /* offline: check next time */ });
    }
    // Shopify's own /cart (the bag icon at checkout) and /search?q= open the bag and the search here
    if (window.FOMO_OPEN === 'bag') openOverlay('bag');
    if (window.FOMO_OPEN === 'search') { openOverlay('search'); if (window.FOMO_Q) { $('#q').value = window.FOMO_Q; renderSearch(); } }
  }
  window.FOMO_APP = { S, byKey, route, openOverlay, closeOverlay, introLog: () => INTRO_LOG };
})();
